import React, { useState, useEffect, useRef} from "react";
import { useSelector, useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import moment from "moment";
import _ from "lodash";
import "./index.css"

import { 
    TextInputField, 
    Button, 
    DropDownField, 
    MultiSelectField, 
    InputSwitchField, 
    AutoCompleteField,
    TextAreaField,
    CalendarField,
    Table
} from "../../../helpers";
import Menu from "../../../helpers/Menu"
import Steps from "../../../helpers/Steps";
import googleChatIcon from "../../../images/google_chat_icon.png"


import { FileUpload } from 'primereact/fileupload';
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import { Toast } from 'primereact/toast';
import { useNavigate, useParams } from "react-router-dom";
import { Tooltip } from "primereact/tooltip";
import { ConfirmDialog } from 'primereact/confirmdialog'

import Loading from "../../../common/Loading"
import SACCode from "../../../common/SACCode"
import AddBillingAddress from "../../../common/AddBillingAddress"

import { 
    checkPermissions, 
    validateInputs, 
    GSTIN_REGEX_FORMAT, 
    sortArrayOfObjectsInAlphabeticalOrder, 
    getFullName,
    getApproverDetails,
    sortArrayOfObjectsInAscendingDateOrder,
    combineISDCodeWithPhoneNumber,
    phoneNumberWithISDCode,
    SACCodes,
    isMobile,
    getUploadedFileObj,
    getDateTimeString,
    getDateString
} from '../../../utils'

import { 
    EditCompanyDetailValidationSchema, 
    EditCompanyRolesValidationSchema,
    EditCompanyUsersValidationSchema
} from "../../../validation/editCompanyValidation";

import { 
    fetchStates, 
    fetchMaterialCategories, 
    fetchPinCodes, 
    fetchClientSuccessManagers,
    fetchTDSSections,
    fetchStatus,
    fetchApprovals,
    fetchApprovalSecondary,
    fetchCountries,
    fetchCompanyMSMEDTypes,
    fetchHSNMasterData,
    fetchCompanyTags,
    fetchMaterialBrands
} from "../../../services/redux/reducers/commonThunk";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

import ViewGSTINs from "./Components/ViewGSTINs";

import { getStateDataByCountry } from '../../../services/api/state'
import { getInitialData, uploadFile, getCompanyWithGSTIN, updateCompanyDetails, verifyGSTINsByPanNumber, getCompanyProcessStatus } from '../../../services/api/company';
import { getClientSuccessManagers } from "../../../services/api/user";
import { getApprovalInstancesByCompanyId } from "../../../services/api/approvalInstances";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";
import { verifyCompanyGSTINs, getCompanyGSTINs } from "../../../services/api/companyGSTINs";
import { getGoogleUserChatUri } from "../../../services/api/googleChat";
import { getCompanyCertificates } from "../../../services/api/companyCertificates";

import CompanySkeleton from "../../../skeletons/CompanySkeleton";
import CompanyMobileSkeleton from "../../../skeletons/CompanyMobileSkeleton";

import FileViewAndRemove from "../../../common/FileViewAndRemove";

let newPMBranch = {
    branchId: 0,
    branchName: "All",
    statusId: 1
}


const CompanyEdit = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [visibleAddNewBillingAddr, setVisibleAddNewBillingAddr] = useState(false)

    const [initialData, setInitialData] = useState({})
    const [relatedCompanyGroupTypes, setRelatedCompanyGroupTypes] = useState([])
    const [companyDetails, setCompanyDetails] = useState({})
    const [editedCompanyDetails, setEditedCompanyDetails] = useState([])
    const [companyBillAddrs, setCompanyBillAddrs] = useState([])
    const [editedCompanyBillAddrs, setEditedCompanyBillAddrs] = useState([])
    const [companyGSTIN, setCompanyGSTIN] = useState([])
    const [editedCompanyGSTIN, setEditedCompanyGSTIN] = useState([])
    const [companyRoles, setCompanyRoles] = useState([])
    const [editedCompanyRoles, setEditedCompanyRoles] = useState([])
    const [companyUsers, setCompanyUsers] = useState([])
    const [companyUsersSuggestions, setCompanyUsersSuggestions] = useState([])
    let [editedCompanyUsers, setEditedCompanyUsers] = useState([])
    const [skeletonLoading, setSkeletonLoading] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [userName, setUserName] = useState('')
    const [isPANVerified, setIsPANVerified] = useState(false)
    const [isGSTINDataLoading, setIsGSTINDataLoading] = useState(false)
    const [formErrors, setFormErrors] = useState({})
    const [formCompanyRolesErrors, setFormCompanyRolesErrors] = useState({})
    const [formCompanyUsersErrors, setFormCompanyUsersErrors] = useState({})
    const [isEditing, setIsEditing] = useState(false)
    const [prefPMStateList, setPrefPMStateList] = useState([])
    const [searchedClientSuccessManagers, setSearchedClientSuccessManagers] = useState([])
    const [visibleApprovalRemarks, setVisibleApprovalRemarks] = useState(false)
    const [tdsApprovalRemarks, setTDSApprovalRemarks] = useState('')
    const [editedAllCompanyDetails, setEditedAllCompanyDetails] = useState({})
    const [paymentTermsApprovalRemarks, setPaymentTermsApprovalRemarks] = useState('')
    const [preferredPaymentModeRemarks, setpreferredPaymentModeRemarks] = useState('')
    const [tdsApprovalInstanceData, setTDSApprovalInstanceData] = useState({})
    const [preferredPaymentModeApprovalInstanceData, setPreferredPaymentModeApprovalInstanceData] = useState({})
    const [paymentTermsApprovalInstanceData, setPaymentTermsApprovalInstanceData] = useState({})
    const [companyOnboardingApprovalInstanceData, setCompanyOnboardingApprovalInstanceData] = useState({})
    const [approvalInstancesData, setApprovalInstancesData] = useState([])
    const [companyOnboardingApprovalRemarks, setCompanyOnboardingApprovalRemarks] = useState('')
    const [SACCodesData, setSACCodesData] = useState([])
    const [selectedSACCode, setSelectedSACCode] = useState(null)
    const [visibleSACCode, setVisibleSACCode] = useState(false)
    const [selectedGSTIN, setSelectedGSTIN] = useState("")

    const [visibleViewGSTINs, setVisibleViewGSTINs] = useState(false)
    const [tagOptions, setTagOptions] = useState([])
    const [isConfirmTagDeleteDialogVisible, setIsConfirmTagDeleteDialogVisible] = useState(false)
    const [selectedCompanyTagId, setSelectedCompanyTagId] = useState(null)
    const [visibleAddBrandCertificate, setVisibleAddBrandCertificate] = useState(false)
    const [brandCertificate, setBrandCertificate] = useState({})
    const [brandCertificates, setBrandCertificates] = useState([])
    const [initialBrandCertificates, setInitialBrandCertificates] = useState([])
    const [searchedMaterialBrands, setSearchedMaterialBrands] = useState([])
    const [brandCertificateApprovalInstanceData, setBrandCertificateApprovalInstanceData] = useState({})

    const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
    const materialCategoriesRedux = useSelector((state) => state.common.materialCategories)
    const statesDetails = useSelector((state) => state.common.states)
    const countriesData = useSelector(state => state.common.countries)
    const userId = useSelector((state) => state.userDetails.userId)
    const userDetails = useSelector((state) => state.userDetails)

    const pinCodesData = useSelector(state => state.common.pinCodes)
    const clientSuccessManagers = useSelector(state => state.common.clientSuccessManagers)
    const tdsSections = useSelector(state => state.common.tdsSections)
    const statusList = useSelector((state) => state.common.status)
    const stateList = useSelector(state => state.common.states)
    const approvals = useSelector((state) => state.common.approvals)
    const approvalSecondary = useSelector((state) => state.common.approvalSecondary)
    const companyMSMEDTypes = useSelector(state => state.common.companyMSMEDTypes)
    const HSNMasterData = useSelector((state) => state.common.HSNMaster)
    const companyTags = useSelector(state => state.common.companyTags)
    const materialBrands = useSelector((state) => state.common.materialBrands)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    const toast1 = useRef(null)
    const addTagsMenu = useRef(null)
    
    newPMBranch.companyId = pmCompanyDetails.companyId

    const tagsConfig = [...companyTags]
    
    let {isPermitted: isIndustryInputPermitted} = checkPermissions({...userDetails, userRoleId: userDetails.activeRoleId, permissions: [198]})
    let materialCategories = materialCategoriesRedux.map(eachMaterialCategory => {
        if (eachMaterialCategory.categoryName && eachMaterialCategory.categoryName.toLowerCase() === "bio mass" && !isIndustryInputPermitted) {
            return { ...eachMaterialCategory, optionDisabled: true }
        }
        return { ...eachMaterialCategory }
    })

    let prefPMBranchPermissionDetails = checkPermissions({ ...userDetails, permissions: [213] })
    const prefPMBranches = [{ ...newPMBranch, optionDisabled: !prefPMBranchPermissionDetails.isPermitted }, ...pmCompanyDetails?.companyBranches]

    let brandCertificatesPermissionDetails = checkPermissions({ ...userDetails, permissions: [213] })

    useEffect(() => {
        dispatch(fetchCompanyTags())
        dispatch(fetchStates())
        dispatch(fetchCountries())
        dispatch(fetchPinCodes())
        dispatch(fetchMaterialCategories())
        dispatch(fetchClientSuccessManagers())
        dispatch(fetchTDSSections())
        dispatch(fetchStatus())
        dispatch(fetchApprovals())
        dispatch(fetchApprovalSecondary())
        dispatch(fetchCountries())
        dispatch(fetchCompanyMSMEDTypes())
        dispatch(fetchHSNMasterData())
        dispatch(fetchMaterialBrands())
    }, [])

    useEffect(() => {
        if(countriesData.length){
            if((pmCompanyConfig.companyApprovalTypeIds.length && approvals.length) || !pmCompanyConfig.companyApprovalTypeIds.length) {
                getCompanyInitialData()
            }
        }
    }, [countriesData, approvals])

    useEffect(() => {
        if(HSNMasterData?.length > 0){
            let uniqHSNCodes = _.uniqBy(HSNMasterData, "HSNCode")
            
            let relatedHSNCodes = uniqHSNCodes
                .filter(eachHSN => SACCodes.includes(eachHSN.HSNCode))
                .map(eachHSN => ({
                    ...eachHSN,
                    HSNCode: eachHSN.HSNCode.toString()
                }))
            setSACCodesData(relatedHSNCodes)
        }
    },[HSNMasterData])

    useEffect(() => {
        if (initialData.companyTypesData) {
            let updatedCompanyTypesData = initialData.companyTypesData
            if (companyDetails.buyerSeller === 1) {
                updatedCompanyTypesData = updatedCompanyTypesData.map(eachCompanyType => {
                    if (eachCompanyType.companyTypeId === 2) {
                        return { ...eachCompanyType, disabled: true }
                    }
                    return eachCompanyType
                })
            } 
            else if (companyDetails.buyerSeller === 2) {
                updatedCompanyTypesData = updatedCompanyTypesData.map(eachCompanyType => {
                    if (eachCompanyType.companyTypeId === 1) {
                        return { ...eachCompanyType, disabled: true }
                    }
                    return eachCompanyType
                })
            }
            else if (companyDetails.buyerSeller === 3) {
                updatedCompanyTypesData = updatedCompanyTypesData.map(eachCompanyType => {
                    if ([1,2].includes(eachCompanyType.companyTypeId)) {
                        return { ...eachCompanyType, disabled: true }
                    }
                    return eachCompanyType
                })
            }
            setInitialData({ ...initialData, companyTypesData: updatedCompanyTypesData })
        }
    }, [companyDetails])

    useEffect(() => {
        if(materialBrands.length){
            getCompanyBrandCertificates()
        }
    }, [materialBrands])

    const items = [
        {
            label: 'Company Details'
        },
        {
            label: 'Users',
            command: () => { navigate(`/company/users/${id}`); } 
        },
        {
            label: 'Branch',
            command: () => { navigate(`/company/branches/${id}`); } 
        },
        {
            label: 'Bank Accounts',
            command: () => { navigate(`/company/bank_details/${id}`); } 
        },
        {
            label: 'Rate Contract',
            command: () => { navigate(`/company/ratecontract/${id}`); } 
        }
    ]

    if([2, 3].includes(companyDetails?.buyerSeller)){
        items.push(
            {
                label: 'Seller Profile',
                command: () => { navigate(`/company/seller-profile/${id}`); } 
            }
        )
    }

    const getCompanyInitialData = async() => {
        const clientSuccessManagerDataResponse = await getClientSuccessManagers()

        const initialData = await getInitialData()
        if(initialData){
            const initial_data = initialData.data

            initialData.data.companyGroupsData = sortArrayOfObjectsInAlphabeticalOrder(initialData.data.companyGroupsData, "groupName")
            initialData.data.companyBusinessTypesData = sortArrayOfObjectsInAlphabeticalOrder(initialData.data.companyBusinessTypesData.filter(eachBusinessType => eachBusinessType.statusId === 1), "businessType")
            initialData.data.companyOwnershipTypesData = sortArrayOfObjectsInAlphabeticalOrder(initialData.data.companyOwnershipTypesData, "ownershipType")
            initialData.data.companySizeCategoriesData = initialData.data.companySizeCategoriesData.filter(eachSizeCategory => eachSizeCategory.statusId === 1)
            initialData.data.companyTurnoverCategoriesData = initialData.data.companyTurnoverCategoriesData.filter(eachTurnoverCategory => eachTurnoverCategory.statusId === 1)

            setInitialData({ ...initial_data })

            const countries = initial_data?.countryData
            const selected_country = countries?.find(country => country.countryId == companyDetails.countryId)
            if (selected_country) {
                const country_id = selected_country.countryId
                getStateData(country_id)
            }

            let clientSuccessManagersData = []
            if (clientSuccessManagerDataResponse?.data?.length > 0) {
                clientSuccessManagersData = clientSuccessManagerDataResponse?.data?.map(eachUser => {
                    return { ...eachUser, fullName: getFullName(eachUser.firstName, eachUser.lastName) }
                })
            }

            getCompnayData(initial_data?.companyGroupsData, clientSuccessManagersData)
            await getApprovalInstances()
        }
    }

    const getCompnayData = async (companyGroupsData, clientSuccessManagerData) => {
        const company_id = id
        const companyData = await getCompanyWithGSTIN(company_id)
    
        if(companyData.status = 1){
            setSkeletonLoading(false)
            const company_data = companyData.data
            
            if(company_data){
                company_data.companyBranches = company_data.companyBranches?.filter(branch=> branch.statusId === 1)

                const hodUser = company_data.companyUsers?.find(obj => obj.userId == company_data.companyHOD)
                company_data.hodUser = hodUser
                company_data.address = company_data.addr

                if(!company_data.paymentTerms){
                    company_data.paymentTerms = JSON.parse(company_data.paymentTerms)
                }else{
                    if(company_data.paymentTerms && typeof company_data.paymentTerms === 'string'){
                        company_data.paymentTerms = JSON.parse(company_data.paymentTerms)
                    } 
                }
                
                if(company_data.paymentTerms && !company_data.paymentTerms?.creditPeriodId){
                    company_data.paymentTerms.creditPeriodId = 0
                }

                if(company_data.statusId === 5 || company_data.statusId === 7){
                    company_data.partialOnboarding = true
                }else{
                    company_data.partialOnboarding = false
                }

                if(company_data.tdsSection194q === null){
                    company_data.tdsSection194q = false
                }

                if(company_data.tdsSectionId && company_data.tdsSectionId !== 1){
                    company_data.enableServicePurchase = true
                }else{
                    company_data.enableServicePurchase = false
                }

                if(company_data.groupId){
                    company_data.groupId = companyGroupsData?.find(eachGroup => eachGroup.groupId === company_data.groupId)
                }
                
                if(company_data.clientSuccessManagerId){
                    company_data.clientSuccessManagerId = clientSuccessManagerData?.find(eachUser => eachUser.userId === company_data.clientSuccessManagerId)
                }
                
                // if (company_data.tags) {
                //     const updatedCompanyTags = companyTags
                //         .filter(eachTag => Object.keys(company_data.tags).includes(eachTag.tagName))
                //         .map(eachTag => ({
                //             ...eachTag,
                //             tagValue: company_data.tags[eachTag.tagName]
                //         }))
                
                //     setTagOptions(updatedCompanyTags)
                // }
                
                
                let sortedGSTINs = sortArrayOfObjectsInAlphabeticalOrder(company_data?.companyGSTIN, "gstinCode")
                sortedGSTINs = sortedGSTINs.filter(eachGSTINs => eachGSTINs.gstinCode)
                
                setCompanyGSTIN(sortedGSTINs)
                setEditedCompanyGSTIN(JSON.parse(JSON.stringify(sortedGSTINs)))

                setCompanyBillAddrs(company_data.companyBillAddrs)
                setEditedCompanyBillAddrs(JSON.parse(JSON.stringify(company_data.companyBillAddrs)))

                setCompanyRoles(company_data.companyRoles)
                setEditedCompanyRoles(JSON.parse(JSON.stringify(company_data.companyRoles)))

                company_data.companyUsers.map(eachUser=>{
                    if(eachUser?.firstName && eachUser?.lastName){
                        eachUser.fullName = `${eachUser.firstName} ${eachUser.lastName}`
                    }else{
                        eachUser.fullName = eachUser.firstName
                    }
                    
                    if (eachUser.phoneNumber) {
                        eachUser.phoneNumber = phoneNumberWithISDCode(eachUser.phoneNumber)
                    }

                    let relatedCompanyRoles = eachUser.userRoles.find(eachRole => !eachRole.branchId)
                    if(relatedCompanyRoles){
                        eachUser.userRoles = relatedCompanyRoles
                    }else{
                        delete eachUser.userRoles
                    }
                    return eachUser
                })
                
                setCompanyUsers(company_data.companyUsers)
                let relatedActiveCompanyUsers = company_data.companyUsers.filter(eachUser => eachUser.statusId === 1 && eachUser?.userRoles?.branchId === 0)
                setEditedCompanyUsers(JSON.parse(JSON.stringify(relatedActiveCompanyUsers)))

                delete company_data.companyBankAccounts
                delete company_data.companyBranchShipAddrs
                delete company_data.companyBranches
                delete company_data.companyGSTIN
                delete company_data.companyRoles
                delete company_data.tags

                setCompanyDetails(JSON.parse(JSON.stringify(company_data)))
                setEditedCompanyDetails(JSON.parse(JSON.stringify(company_data)))
            }
        }
    }

    const getApprovalInstances = async() => {
        const relatedCompanyApprovals = approvals.filter(eachApproval => pmCompanyConfig.companyApprovalTypeIds.includes(eachApproval.approvalTypeId))
        const relatedCompanyApprovalIds = relatedCompanyApprovals.map(eachApproval => eachApproval.approvalId)
        let data = {
            companyType: "sellerCompanyId",
            approvalIds: relatedCompanyApprovalIds,
            statusIds: [8, 9, 12]
        }
        
        const approvalInstancesResponse = await getApprovalInstancesByCompanyId(id, data)
        // console.log("approvalInstancesResponse", approvalInstancesResponse)
        if (approvalInstancesResponse?.failure){
            return dispatch(raiseToast({ severity: 'error', detail: approvalInstancesResponse?.data?.error, life: 3000 }))
        }else{

            let relatedTDSApprovalInstances = approvalInstancesResponse.data.filter(eachInstance => {
                if(eachInstance.statusId !== 9){
                    const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === eachInstance.approvalId)

                    if (relatedApproval.approvalTypeId === 18){
                        return true
                    }
                }
                
                return false
            })

            let relatedPaymentTermsApprovalInstances = approvalInstancesResponse.data.filter(eachInstance => {
                if (eachInstance.statusId !== 9) {
                    const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === eachInstance.approvalId)

                    if (relatedApproval.approvalTypeId === 19) {
                        return true
                    }
                }

                return false
            })

            let regionalHeadOnboardingApprovalInstances = []
            let dataOpsOnboardingApprovalInstances = []
            let relatedCompanyOnboardingApprovalInstances = approvalInstancesResponse.data.map(eachInstance => {
                const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === eachInstance.approvalId)

                if (relatedApproval.approvalTypeId === 25){
                    if(relatedApproval.primaryApprover === 13){
                        regionalHeadOnboardingApprovalInstances.push(eachInstance)
                    }else if(relatedApproval.primaryApprover === 9){
                        dataOpsOnboardingApprovalInstances.push(eachInstance)
                    }
                }
                return eachInstance
            })
            
            let relatedPreferredPaymentModeApprovalInstances = approvalInstancesResponse.data.filter(eachInstance => {
                if(eachInstance.statusId !== 9){
                    const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === eachInstance.approvalId)

                    if (relatedApproval.approvalTypeId === 27){
                        return true
                    }
                }

                return false
            })

            let relatedBrandCertificatesApprovalInstances = approvalInstancesResponse.data.filter(eachInstance => {
                if(eachInstance.statusId !== 9){
                    const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === eachInstance.approvalId)

                    if (relatedApproval.approvalTypeId === 43){
                        return true
                    }
                }
                return false
            })
            

            let sortedTDSApprovalInstancesByDate = sortArrayOfObjectsInAscendingDateOrder(relatedTDSApprovalInstances, "createdAt", "DESC")
            let sortedPaymentTermsApprovalInstancesByDate =  sortArrayOfObjectsInAscendingDateOrder(relatedPaymentTermsApprovalInstances, "createdAt", "DESC")
            let sortedPreferredPaymentModeApprovalInstancesByDate = sortArrayOfObjectsInAscendingDateOrder(relatedPreferredPaymentModeApprovalInstances, "createdAt", "DESC")
            let sortedBrandCertificatesApprovalInstancesByDate = sortArrayOfObjectsInAscendingDateOrder(relatedBrandCertificatesApprovalInstances, "createdAt", "DESC")
            let sortedRegionalHeadOnboardingApprovalInstancesByDate = sortArrayOfObjectsInAscendingDateOrder(regionalHeadOnboardingApprovalInstances, "createdAt", "DESC")
            let sortedDataOpsOnboardingApprovalInstancesByDate = sortArrayOfObjectsInAscendingDateOrder(dataOpsOnboardingApprovalInstances, "createdAt", "DESC")
            
            setTDSApprovalInstanceData(sortedTDSApprovalInstancesByDate[0])
            setPaymentTermsApprovalInstanceData(sortedPaymentTermsApprovalInstancesByDate[0])
            setPreferredPaymentModeApprovalInstanceData(sortedPreferredPaymentModeApprovalInstancesByDate[0])
            setBrandCertificateApprovalInstanceData([...sortedBrandCertificatesApprovalInstancesByDate])
            setApprovalInstancesData([...approvalInstancesResponse.data])


            const latestRegionalHeadOnboardingApproval = sortedRegionalHeadOnboardingApprovalInstancesByDate[0]
            const latestDataOpsOnboardingApproval = sortedDataOpsOnboardingApprovalInstancesByDate[0]

            if ([12, 8].includes(latestRegionalHeadOnboardingApproval?.statusId)) {
                setCompanyOnboardingApprovalInstanceData({
                    regionalHead: latestRegionalHeadOnboardingApproval,
                })
            } else if (latestDataOpsOnboardingApproval?.statusId === 9) {
                setCompanyOnboardingApprovalInstanceData({})
            } else {
                setCompanyOnboardingApprovalInstanceData({
                    regionalHead: latestRegionalHeadOnboardingApproval,
                    dataOps: latestDataOpsOnboardingApproval
                })
            }
        }
    }

    const getCompanyBrandCertificates = async() => {
        let data = {
            companyIds: [id],
            statusIds: [1, 7, 3]
        }
        const brandCertificatesResponse = await getCompanyCertificates(data)
        console.log("brandCertificatesResponse", brandCertificatesResponse)
        if (brandCertificatesResponse?.failure){
            return dispatch(raiseToast({ severity: 'error', detail: brandCertificatesResponse?.data?.error, life: 3000 }))
        }else{
            let brandCertificatesResData = brandCertificatesResponse.data.data
            if(brandCertificatesResData.length){
                let updatedBrandCertificates = brandCertificatesResData.map(eachBrandCertificate => {
                    const relatedBrand = materialBrands.find(eachBrand => eachBrand.brandId === eachBrandCertificate.entityId)
                    return { 
                        ...eachBrandCertificate, 
                        entityId: relatedBrand,
                        issuedDate: new Date(eachBrandCertificate.issuedDate),
                        expiryDate: new Date(eachBrandCertificate.expiryDate),
                        brandCertificateId: eachBrandCertificate.companyCertificateId
                    }
                })
                setBrandCertificates([...updatedBrandCertificates])
                setInitialBrandCertificates([...updatedBrandCertificates])
            }
        }
    }

    const updateCompany = async () => {
        let updatedEditCompanyDetails = {...editedCompanyDetails, isInternational: pmCompanyConfig.isInternational}
        const companyDetailsValidation = await validateInputs(EditCompanyDetailValidationSchema, updatedEditCompanyDetails, pmCompanyConfig)
        const companyRolesValidation = await validateInputs(EditCompanyRolesValidationSchema, editedCompanyRoles)
        const companyUsersValidation = await validateInputs(EditCompanyUsersValidationSchema, editedCompanyUsers)

        if (companyDetailsValidation  || companyRolesValidation || companyUsersValidation) {
            if (companyDetailsValidation.error || companyRolesValidation.error || companyUsersValidation.error) {
                if(companyDetailsValidation.error){
                    setFormErrors(companyDetailsValidation.error)
                    Object.keys(companyDetailsValidation.error).map(eachError => {
                        dispatch(raiseToast({ severity: 'warn', detail: companyDetailsValidation.error[eachError], life: 3000 }))
                    })
                }

                if(companyRolesValidation.error){
                    setFormCompanyRolesErrors(companyRolesValidation.error)
                    Object.keys(companyRolesValidation.error).map(eachError => {
                        dispatch(raiseToast({ severity: 'warn', detail: companyRolesValidation.error[eachError], life: 3000 }))
                    })
                }
                
                if(companyUsersValidation.error){
                    setFormCompanyUsersErrors(companyUsersValidation.error)
                    Object.keys(companyUsersValidation.error).map(eachError => {
                        dispatch(raiseToast({ severity: 'warn', detail: companyUsersValidation.error[eachError], life: 3000 }))
                    })
                }
                
            }
            else {
                const updated_company_details = { ...editedCompanyDetails, ...companyDetailsValidation.result }
                setEditedCompanyDetails({ ...editedCompanyDetails, ...companyDetailsValidation.result })
                setFormErrors({})
                setFormCompanyRolesErrors({})
                setFormCompanyUsersErrors({})

                if (is_buyer) {
                    updated_company_details.isMSMEDRegd = null
                    updated_company_details.tdsSection194q = false
                    updated_company_details.gstCert = null
                    updated_company_details.aadharCert = null
                    updated_company_details.panCert = null
                    updated_company_details.msmedCert = null
                    updated_company_details.incorporationCert = null
                    updated_company_details.isBuyer = true
                }
                else{
                    if(updated_company_details.buyerSeller !== 1 && !updated_company_details.partialOnboarding){
                        if(updated_company_details.isMSMEDRegd != ""){
                            if (updated_company_details.isMSMEDRegd) {
                                updated_company_details.isMSMEDRegd = true
                            }
                            else {
                                updated_company_details.isMSMEDRegd = false
                            }
        
                            if(updated_company_details.isMSMEDRegd && !updated_company_details.msmedCert){
                                return dispatch(raiseToast({ severity: 'warn', detail: "Please upload msmed certificate", life: 3000 }))
                            }else{
                                if (!pmCompanyConfig.isInternational){
                                    if(!updated_company_details.isMSMEDRegd && !updated_company_details.msmedCert){
                                        return dispatch(raiseToast({ severity: 'warn', detail: "Please upload pdf or screenshot of the email confirmation from the vendor about MSMED act registration status", life: 3000 }))
                                    }
                                }
                            }
                        }


                        if(!updated_company_details.gstCert && (updated_company_details.gstinCode && !["URD", "URP"].includes(updated_company_details.gstinCode))){
                            return dispatch(raiseToast({ severity: 'warn', detail: "Please upload gstin certificate", life: 3000 }))
                        }
                    }                  
                }

                if (!updated_company_details?.panCode && !companyDetails.panCode){
                    updated_company_details.companyShortName = updated_company_details?.companyName
                }

                if (updated_company_details?.gstinCode?.trim()) {
                    updated_company_details.gstinCode = updated_company_details?.gstinCode?.trim()
                    if(updated_company_details.gstinCode !== "URD" && updated_company_details.gstinCode !== "URP"){
                        if (!pmCompanyConfig.isInternational){
                            if (updated_company_details.gstinCode?.length !== 15) {
                                return dispatch(raiseToast({ severity: 'warn', detail: "GSTIN must be exactly 15 characters only", life: 3000 }))
                            }
                            if (!GSTIN_REGEX_FORMAT.test(updated_company_details.gstinCode)) {
                                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter valid GSTIN", life: 3000 }))
                            }
                            let panAndGstinMatch = panAndGstinMatchValidation(updated_company_details.panCode, updated_company_details.gstinCode)
                            if (!panAndGstinMatch) {
                                return dispatch(raiseToast({ severity: 'warn', detail: "GSTIN and PAN entered are not for the same entity.", life: 3000 }))
                            }
                        }
                    }
                }else{
                    updated_company_details.gstinCode = updated_company_details?.gstinCode?.trim()
                }


                let isManuallyEnterGSTIN = false
                if(companyDetails.panCode && editedCompanyDetails.gstinCode?.length === 15){
                    if ((companyGSTIN?.length === 1 && (companyGSTIN[0]?.gstinCode === "URD" || companyGSTIN[0]?.gstinCode === "URP")) || companyGSTIN?.length === 0) {
                        isManuallyEnterGSTIN = true
                    }
                }
                
                let notValidGSTINs = []
                let updatedCompanyGSTINs = []
                let updatedCompanyBillAddrs = []
                let manuallyEnterGSTINObj = null
                let manuallyEnterGSTINBillAddr = null

                if (isManuallyEnterGSTIN) {
                    if (isPANVerified) {
                        if (editedCompanyDetails?.gstinCode?.length === 15) {
                            manuallyEnterGSTINObj = {
                                companyId: editedCompanyDetails.companyId,
                                gstinCode: editedCompanyDetails.gstinCode,
                                statusId: 1,
                                gstinTradeName: editedCompanyDetails.companyName,
                            }

                            manuallyEnterGSTINBillAddr = {
                                gstinCode: editedCompanyDetails.gstinCode,
                                billAddress: editedCompanyDetails.address,
                                pinCode: editedCompanyDetails.pinCode,
                                statusId: 1,
                                gstinSeq: 1,
                                companyId: editedCompanyDetails.companyId,
                                stateId: editedCompanyDetails.stateId,
                                loc: editedCompanyDetails.city
                            }
                        }
                    }
                    else {
                        return dispatch(raiseToast({ severity: 'warn', detail: "Please verify pan code", life: 3000 }))
                    }
                }

                const relatedCompanyGSTIN = editedCompanyGSTIN.find(eachGSTIN => eachGSTIN?.gstinCode === editedCompanyDetails.gstinCode)
                if (relatedCompanyGSTIN && relatedCompanyGSTIN.gstinTradeName) {
                    updated_company_details.companyShortName = relatedCompanyGSTIN.gstinTradeName
                } else {
                    updated_company_details.companyShortName = updated_company_details.companyName
                }
                
                if (pmCompanyConfig.isInternational){
                    if (!editedCompanyBillAddrs.length && !companyBillAddrs.length){
                        return dispatch(raiseToast({severity:'warn', detail: "Please Add the billing address", life: 3000}))
                    }else {
                        editedCompanyBillAddrs.map(eachBillAddr => {
                            if (eachBillAddr.isNew){
                                const relatedState = statesDetails?.find(eachState => eachState.stateId === eachBillAddr.stateId)

                                let ledgerName = ''
                                if (eachBillAddr?.tradeNam) {
                                    ledgerName = eachBillAddr?.tradeNam + "_" + relatedState?.stateCode
                                } else {
                                    if (relatedState && relatedState.stateCode){
                                        ledgerName = companyDetails.companyName + "_" + relatedState.stateCode
                                    }else{
                                        ledgerName = companyDetails.companyName
                                    }
                                }
    
                                eachBillAddr = { ...eachBillAddr, gstinCode: updated_company_details.gstinCode, ledgerName: ledgerName }
                                updatedCompanyBillAddrs.push(eachBillAddr)
                            }
                        })
                    }

                    if (updatedEditCompanyDetails.gstinCode){
                        const isGSTINAlreadyExists = companyGSTIN.find(eachCompanyGSTIN => eachCompanyGSTIN.gstinCode === updatedEditCompanyDetails.gstinCode)

                        if (!isGSTINAlreadyExists){
                            let newCompanyGSTIN = {
                                gstinCode: updatedEditCompanyDetails.gstinCode,
                                createdBy: userDetails.userId,
                                updatedBy: userDetails.userId,
                                tradeNam: companyDetails.companyName
                            }

                            const relatedState = statesDetails?.find(eachState => eachState?.stateId === pmCompanyConfig.defaultStateId)

                            newCompanyGSTIN.ledgerName =  companyDetails.companyName + "_" + relatedState?.stateCode
                            updatedCompanyGSTINs.push(newCompanyGSTIN)
                        }
                    }
                }

                if(notValidGSTINs.length > 0){
                    return dispatch(raiseToast({severity:'warn', detail: "GSTINs verification was failed, Please check the GSTINs with pan has same entity. If not found contact tech support.", life: 3000}))
                }
                
                if (updated_company_details.paymentTerms) {
                    let total_payment_percentage = 0
                    if (updated_company_details.paymentTerms?.payAdvPO || updated_company_details.paymentTerms?.payAdvDelivery || updated_company_details.paymentTerms?.payPDCDelivery || updated_company_details.paymentTerms?.payOnDelivery || updated_company_details.paymentTerms?.payCredit) {
                        if (updated_company_details.paymentTerms?.payAdvPO) {
                            updated_company_details.paymentTerms.payAdvPO = parseFloat(updated_company_details.paymentTerms.payAdvPO)
                            total_payment_percentage += updated_company_details.paymentTerms.payAdvPO
                        }else{
                            updated_company_details.paymentTerms.payAdvPO = 0
                        }

                        if (updated_company_details.paymentTerms?.payAdvDelivery) {
                            updated_company_details.paymentTerms.payAdvDelivery = parseFloat(updated_company_details.paymentTerms.payAdvDelivery)
                            total_payment_percentage += updated_company_details.paymentTerms.payAdvDelivery
                        }else{
                            updated_company_details.paymentTerms.payAdvDelivery = 0
                        }

                        if (updated_company_details.paymentTerms?.payOnDelivery) {
                            updated_company_details.paymentTerms.payOnDelivery = parseFloat(updated_company_details.paymentTerms.payOnDelivery)
                            total_payment_percentage += updated_company_details.paymentTerms.payOnDelivery
                        }else{
                            updated_company_details.paymentTerms.payOnDelivery = 0
                        }

                        if ((updated_company_details.paymentTerms?.payCredit && updated_company_details.paymentTerms?.payCredit != 0) || (updated_company_details.paymentTerms?.payPDCDelivery && updated_company_details.paymentTerms?.payPDCDelivery != 0)) {
                            if (updated_company_details.paymentTerms?.payCredit && updated_company_details.paymentTerms?.payCredit != 0) {
                                updated_company_details.paymentTerms.payCredit = parseFloat(updated_company_details.paymentTerms.payCredit)
                                total_payment_percentage += updated_company_details.paymentTerms.payCredit
                            }else{
                                updated_company_details.paymentTerms.payCredit = 0
                            }

                            if (updated_company_details.paymentTerms?.payPDCDelivery && updated_company_details.paymentTerms?.payPDCDelivery != 0) {
                                updated_company_details.paymentTerms.payPDCDelivery = parseFloat(updated_company_details.paymentTerms.payPDCDelivery)
                                total_payment_percentage += updated_company_details.paymentTerms.payPDCDelivery
                            }else{
                                updated_company_details.paymentTerms.payPDCDelivery = 0
                            }

                            if (!updated_company_details.paymentTerms?.creditPeriodId) {
                                return dispatch(raiseToast({ severity: 'warn', detail: "Please select credit period", life: 3000 }))
                            }
                        } else {
                            updated_company_details.paymentTerms.payCredit = 0
                            updated_company_details.paymentTerms.payPDCDelivery = 0
                            // delete updated_company_details.paymentTerms.creditPeriodId
                        }
                    }else{
                        if(!updated_company_details.partialOnboarding){
                            return dispatch(raiseToast({ severity: 'warn', detail: "Please enter payment terms", life: 3000 }))
                        }
                    }
                    
                    if (updated_company_details.paymentTerms?.payAdvPO || updated_company_details.paymentTerms?.payAdvDelivery || updated_company_details.paymentTerms?.payPDCDelivery || updated_company_details.paymentTerms?.payOnDelivery || updated_company_details.paymentTerms?.payCredit) {
                        if (total_payment_percentage !== 100 && total_payment_percentage != 0) {
                            return dispatch(raiseToast({ severity: 'warn', detail: "Total percentage of payment terms should be 100", life: 3000 }))
                        }
                    }
                }
                else {
                    if(!updated_company_details.partialOnboarding){
                        return dispatch(raiseToast({ severity: 'warn', detail: "Please enter payment terms", life: 3000 }))
                    }
                }

                if(updated_company_details.gstinCode){
                    const relatedCompanyGSTIN = editedCompanyGSTIN.find(eachCompanyGSTIN => eachCompanyGSTIN.gstinCode === updated_company_details.gstinCode)
                    if(relatedCompanyGSTIN && [2, 20].includes(relatedCompanyGSTIN.statusId)){
                        return dispatch(raiseToast({ severity: 'error', detail: "Primary GSTIN cannot be INACTIVE/BLACKLISTED"}))
                    }   
                }

                let updatedCompanyDetails = null
                if((JSON.stringify(updated_company_details) !== JSON.stringify(companyDetails)) || tagOptions.length){
                    updatedCompanyDetails = updated_company_details
                }
                
                if(updatedCompanyDetails){
                    updatedCompanyDetails.updatedBy = userId
                    if(!updatedCompanyDetails.partialOnboarding){
                        updatedCompanyDetails.statusId = 1
                    }else{
                        updatedCompanyDetails.statusId = 5
                    }

                    if(updatedCompanyDetails.groupId){
                        updatedCompanyDetails.groupId = updatedCompanyDetails.groupId?.groupId
                    }

                    if(updatedCompanyDetails.clientSuccessManagerId){
                        updatedCompanyDetails.clientSuccessManagerId = updatedCompanyDetails.clientSuccessManagerId?.userId
                    }
                }
                 
                let updatedCompanyRoles = []
                editedCompanyRoles.map(editedRole => {
                    if (editedRole.isNew) {
                        updatedCompanyRoles.push(editedRole)
                    }
                    else {
                        let prevRoleValues = JSON.stringify(companyRoles.find(prevRole => prevRole.companyRoleId === editedRole.companyRoleId))
                        let newRoleValues = JSON.stringify(editedRole)

                        if (newRoleValues !== prevRoleValues) {
                            updatedCompanyRoles.push(JSON.parse(newRoleValues))
                        }
                    }
                })
                
                let relatedHODRole = editedCompanyRoles.find(eachRole => eachRole.companyRoleName === "HOD")
                
                let updatedCompanyUsersRoles = []
                let companyHODUsers = []
                let updatedCompanyUsers = []
                editedCompanyUsers.map(editedUser => {
                    let prevUserValues = companyUsers.find(eachUser => eachUser.userId === editedUser.userId)

                    if(prevUserValues?.statusId !== editedUser.statusId){
                        editedUser.phoneNumber = combineISDCodeWithPhoneNumber(editedUser.ISDCode, editedUser.phoneNumber)
                        updatedCompanyUsers.push(editedUser)
                    }

                    if(editedUser?.userRoles?.companyRoleId === relatedHODRole?.companyRoleId && editedUser.statusId === 1){
                        editedUser.phoneNumber = combineISDCodeWithPhoneNumber(editedUser.ISDCode, editedUser.phoneNumber)
                        companyHODUsers.push(editedUser)
                    }

                    if (editedUser.isNew) {
                        updatedCompanyUsersRoles.push(editedUser.userRoles)
                    }
                    else {
                        prevUserValues = JSON.stringify(prevUserValues)
                        let newUserValues = JSON.stringify(editedUser)

                        if (newUserValues !== prevUserValues) {
                            updatedCompanyUsersRoles.push(JSON.parse(newUserValues).userRoles)
                        }
                    }
                })

                if(companyHODUsers.length > 1){
                    return dispatch(raiseToast({ severity: 'warn', detail: "Company has only 1 HOD", life: 3000 }))
                }

                let confirmMessage = "Do you want to update the company..?"
                
                let approvalConfirmMessage = ""
                if(updatedCompanyDetails && [2, 3].includes(updatedCompanyDetails.buyerSeller)){
                    if((updatedCompanyDetails.tdsSectionId !== companyDetails.tdsSectionId) && updatedCompanyDetails.enableServicePurchase && updatedCompanyDetails.tdsSectionId !== 1){
                        updatedCompanyDetails.isTDSApproval = true
                        approvalConfirmMessage = "Company TDS type is Services. \n"
                    }

                    updatedCompanyDetails.isPaymentTermsApproval = false //handlePaymentTermsApproval(updatedCompanyDetails.paymentTerms, companyDetails.paymentTerms)
                    console.log("updatedCompanyDetails.isPaymentTermsApproval", updatedCompanyDetails.isPaymentTermsApproval)
                    /*if (updatedCompanyDetails.paymentTerms?.payCredit === 100) {
                        if ((updatedCompanyDetails.paymentTerms?.payCredit !== companyDetails.paymentTerms?.payCredit) || (updatedCompanyDetails.paymentTerms?.creditPeriodId !== companyDetails.paymentTerms?.creditPeriodId)) {
                            let relatedCreditPeriod = initialData.companyCreditPeriodsData?.find(eachCreditPeriodTerm => eachCreditPeriodTerm?.creditPeriodId === updated_company_details.paymentTerms?.creditPeriodId)

                            if (relatedCreditPeriod?.creditPeriod < 30) {
                                let relatedCompanyBranchesPaymentTermsApproval = null //approvals.find(eachApproval => eachApproval.approvalId === 38 && eachApproval.statusId === 1)
                                if(relatedCompanyBranchesPaymentTermsApproval){
                                    updatedCompanyDetails.isPaymentTermsApproval = true
                                    approvalConfirmMessage += "Payment terms credit is 100 and credit period is more than NET30. \n"
                                }
                            }
                        }
                    }*/
                    
                    if(companyDetails.statusId !== 1 && updatedCompanyDetails.statusId === 1){
                        updatedCompanyDetails.isCompanyOnboardingApproval = true
                    }
                    
                    if(companyDetails.preferredPaymentMode && updatedCompanyDetails.preferredPaymentMode !== companyDetails.preferredPaymentMode){
                        updatedCompanyDetails.preferredPaymentModeApproval = true
                    }
                }

                if(updatedCompanyDetails && !updatedCompanyDetails.isPaymentTermsApproval){
                    if(JSON.stringify(updated_company_details.paymentTerms) !== JSON.stringify(companyDetails.paymentTerms)){
                        updatedCompanyDetails.isPaymentTermsChanged = true
                        updatedCompanyDetails.previousPaymentTerms = companyDetails.paymentTerms
                    }
                }

                let updatedBrandCertificates = []
                if (brandCertificates.length) {
                    const newlyAddedCertificates = []
                    const modifiedCertificates = []

                    brandCertificates.forEach(currentBrandCert => {
                        const originalBrandCert = initialBrandCertificates.find(
                            cert => cert.brandCertificateId === currentBrandCert.brandCertificateId
                        )

                        if (!originalBrandCert) {
                            newlyAddedCertificates.push(currentBrandCert)
                        } else {
                            const isModified = Object.keys(currentBrandCert).some(
                                key => JSON.stringify(currentBrandCert[key]) !== JSON.stringify(originalBrandCert[key])
                            );
                            if (isModified) {
                                modifiedCertificates.push(currentBrandCert)
                            }
                        }
                    })

                    updatedBrandCertificates = [...newlyAddedCertificates, ...modifiedCertificates]
                }
                
                // if (tagOptions.length) {
                //     let tagsObj = {}
                //     let missingTags = []
                //     tagOptions.forEach(eachTag => {
                //         if (eachTag.tagName) {
                //             let value
                //             if (['integer', 'string', 'select'].includes(eachTag.tagType.toLowerCase())) {
                //                 value = eachTag.tagValue?.trim()
                //                 if (!value) {
                //                     missingTags.push(eachTag.tagLabel || eachTag.tagName)
                //                 }
                //             } else if (['boolean'].includes(eachTag.tagType.toLowerCase())) {
                //                 value = eachTag.tagValue
                //             } else if (['multiselect'].includes(eachTag.tagType.toLowerCase())) {
                //                 value = eachTag.tagValue
                //                 if (!value || (value && value.length === 0)) {
                //                     missingTags.push(eachTag.tagLabel || eachTag.tagName)
                //                 }
                //             }

                //             tagsObj[eachTag.tagName] = value
                //         }
                //     })

                //     if (missingTags.length) {
                //         return dispatch(raiseToast({ severity: 'warn', detail: `Please enter value for ${missingTags.join(", ")} tags`, life: 3000 }))
                //     }

                //     updatedCompanyDetails.tags = Object.keys(tagsObj).length > 0 ? tagsObj : null
                // } else {
                //     updatedCompanyDetails.tags = null
                // }
                
                let updatedCompanyData = {
                    updatedCompanyDetails,
                    updatedCompanyGSTINs,
                    updatedCompanyBillAddrs,
                    prevCompanyBillAddrs: companyBillAddrs,
                    updatedCompanyRoles,
                    updatedCompanyUsersRoles,
                    updatedCompanyUsers,
                    prevCompanyGSTINs: companyGSTIN,
                    manuallyEnterGSTINObj,
                    manuallyEnterGSTINBillAddr,
                    brandCertificates: updatedBrandCertificates
                }
                
                if (updatedCompanyDetails && (updatedCompanyDetails.isTDSApproval || updatedCompanyDetails.isPaymentTermsApproval || updatedCompanyDetails.isCompanyOnboardingApproval || updatedCompanyDetails.preferredPaymentModeApproval)) {
                    if(updatedCompanyDetails.isTDSApproval || updatedCompanyDetails.isPaymentTermsApproval || updatedCompanyDetails.preferredPaymentModeApproval){
                        approvalConfirmMessage +=  "This needs approval from payments team before seller PO created."
                    }
                    
                    if(!(updatedCompanyDetails.isTDSApproval || updatedCompanyDetails.isPaymentTermsApproval)){
                        if(updatedCompanyDetails.preferredPaymentModeApproval){
                            approvalConfirmMessage = " Payment mode update needs approval"
                        }
                    } else {
                        if(updatedCompanyDetails.preferredPaymentModeApproval){
                            approvalConfirmMessage += " Payment mode update needs approval"
                        }
                    }
                    if(updatedCompanyDetails.isCompanyOnboardingApproval){
                        approvalConfirmMessage += "\nCompany is fully onboarding, this needs approval from Data Ops team"
                    }
                    if(window.confirm(approvalConfirmMessage)){
                        setEditedAllCompanyDetails({ ...updatedCompanyData, confirmMessage })
                        setVisibleApprovalRemarks(true)
                    }
                } else {
                    if (window.confirm(confirmMessage)) {
                        setIsLoading(true)
                        const editCompanyDataResponse = await updateCompanyDetails(updatedCompanyData, id)
    
                        if (editCompanyDataResponse?.failure){
                            setIsLoading(false)
                            return dispatch(raiseToast({ severity: 'error', detail: editCompanyDataResponse?.data?.error, life: 3000 }))
                        }else{
                            setIsLoading(false)
                            const data = editCompanyDataResponse.data
                            const message = data?.message
                            
                            if (data?.success) {
                                let updatedData = data?.data
                                if(updatedCompanyDetails){
                                    if(updatedData.companyDetails?.updatedAt){
                                        updatedCompanyDetails.updatedAt = updatedData.companyDetails.updatedAt
                                    }
    
                                    if(updatedCompanyDetails?.groupId){
                                        updatedCompanyDetails.groupId = initialData?.companyGroupsData?.find(eachGroup => eachGroup.groupId === updatedCompanyDetails.groupId)
                                    }
        
                                    if(updatedCompanyDetails?.clientSuccessManagerId){
                                        updatedCompanyDetails.clientSuccessManagerId = clientSuccessManagers?.find(eachUser => eachUser.userId === updatedCompanyDetails.clientSuccessManagerId)
                                    }
                                    
                                    setCompanyDetails(JSON.parse(JSON.stringify(updatedCompanyDetails)))
                                    setEditedCompanyDetails(JSON.parse(JSON.stringify(updatedCompanyDetails)))
                                    setTDSApprovalRemarks("")
                                    setVisibleApprovalRemarks(false)
                                    await getCompanyBrandCertificates()
                                    await getApprovalInstances()
                                }
                                dispatch(raiseToast({ severity: 'success', detail: data.message }))
                            }
                            else {
                                dispatch(raiseToast({ severity: 'error', detail: message }))
                            }
                            setIsEditing(false)
                        }
                    }
                }
            }
        }
    }

    const handleSubmitEditCompanyWithApproval = async () => {
        let { updatedCompanyDetails } = editedAllCompanyDetails

        if (updatedCompanyDetails.isTDSApproval && (!tdsApprovalRemarks || (tdsApprovalRemarks && tdsApprovalRemarks?.trim() === ''))){
            return dispatch(raiseToast({ severity: 'warn', detail: "Enter services type details that will be procure from this vendor", life: 3000 }))
        }else{
            if(updatedCompanyDetails.isTDSApproval && tdsApprovalRemarks.trim().length <= 20){
                return dispatch(raiseToast({ severity: 'warn', detail: "TDS service remarks should be atleast 20 characters", life: 3000 }))
            }
        }

        if (updatedCompanyDetails.isPaymentTermsApproval && (!paymentTermsApprovalRemarks || (paymentTermsApprovalRemarks && paymentTermsApprovalRemarks?.trim() === ''))){
            return dispatch(raiseToast({ severity: 'warn', detail: "Enter payment terms approval remarks", life: 3000 }))
        }

        if (updatedCompanyDetails.preferredPaymentModeApproval && (!preferredPaymentModeRemarks || (preferredPaymentModeRemarks && preferredPaymentModeRemarks?.trim() === ''))){
            return dispatch(raiseToast({ severity: 'warn', detail: "Enter preferred payment mode approval remarks", life: 3000 }))
        }

        if (updatedCompanyDetails.isCompanyOnboardingApproval && (!companyOnboardingApprovalRemarks || (companyOnboardingApprovalRemarks && companyOnboardingApprovalRemarks?.trim() === ''))){
            return dispatch(raiseToast({ severity: 'warn', detail: "Enter company onboarding approval remarks", life: 3000 }))
        }

        updatedCompanyDetails.tdsApprovalRemarks = tdsApprovalRemarks.trim()
        if(selectedSACCode){
            updatedCompanyDetails.tdsApprovalRemarks = `SACCode: ${selectedSACCode.HSNCode}-${selectedSACCode.HSNTitle}. \n` + tdsApprovalRemarks.trim()
        }
        updatedCompanyDetails.paymentTermsApprovalRemarks = paymentTermsApprovalRemarks.trim()
        updatedCompanyDetails.preferredPaymentModeRemarks = preferredPaymentModeRemarks.trim()
        updatedCompanyDetails.companyOnboardingRemarks = companyOnboardingApprovalRemarks.trim()

        if (window.confirm(editedAllCompanyDetails?.confirmMessage)) {
            setSkeletonLoading(true)
            const editCompanyDataResponse = await updateCompanyDetails({...editedAllCompanyDetails, updatedCompanyDetails}, id)

            if (editCompanyDataResponse?.failure) {
                setSkeletonLoading(false)
                return dispatch(raiseToast({ severity: 'error', detail: editCompanyDataResponse?.data?.error, life: 3000 }))
            } else {
                setSkeletonLoading(false)
                const data = editCompanyDataResponse.data
                const message = data?.message

                if (data?.success) {
                    let updatedData = data?.data
                    if (updatedData.companyDetails?.updatedAt) {
                        updatedCompanyDetails.updatedAt = updatedData.companyDetails.updatedAt
                    }

                    if (updatedCompanyDetails?.groupId) {
                        updatedCompanyDetails.groupId = initialData?.companyGroupsData?.find(eachGroup => eachGroup.groupId === updatedCompanyDetails.groupId)
                    }

                    if (updatedCompanyDetails?.clientSuccessManagerId) {
                        updatedCompanyDetails.clientSuccessManagerId = clientSuccessManagers?.find(eachUser => eachUser.userId === updatedCompanyDetails.clientSuccessManagerId)
                    }

                    if ([2, 3].includes(updatedCompanyDetails.buyerSeller)) {
                        if(updatedCompanyDetails.tdsSectionId !== 1 && updatedCompanyDetails?.isTDSApproval){
                            updatedCompanyDetails.tdsSectionId = companyDetails.tdsSectionId
                        if(companyDetails.tdsSectionId !== 1){
                            updatedCompanyDetails.enableServicePurchase = true
                        }else{
                            updatedCompanyDetails.enableServicePurchase = false
                        }
                        }

                        if(updatedCompanyDetails.isPaymentTermsApproval){
                            updatedCompanyDetails.paymentTerms = companyDetails.paymentTerms
                        }
                    }

                    setCompanyDetails(JSON.parse(JSON.stringify(updatedCompanyDetails)))
                    setEditedCompanyDetails(JSON.parse(JSON.stringify(updatedCompanyDetails)))
                    setTDSApprovalRemarks("")
                    setVisibleApprovalRemarks(false)
                    await getCompanyBrandCertificates()
                    await getApprovalInstances()

                    dispatch(raiseToast({ severity: 'success', detail: data.message, life: 3000 }))
                }
                else {
                    dispatch(raiseToast({ severity: 'error', detail: message, life: 3000 }))
                }
                setIsEditing(false)
            }
        }
    }

    const panAndGstinMatchValidation = (panCode, gstin) => {
        if(panCode && gstin){
            if(gstin && gstin.slice(2,12) !== panCode){
                return false
            }
            return true
        }
    }

    const getStateData = (countryId) => {
        const stateData = getStateDataByCountry(countryId)
        stateData.then((state) => {
            const state_list = sortArrayOfObjectsInAlphabeticalOrder(state.data, "stateName")
            if (state_list?.length > 0) {
                setInitialData((data) => ({ ...data, stateList: state_list }))

                let relatedPrefPMStates = state_list?.filter(state => {
                    return pmCompanyDetails?.companyBillAddrs?.find(addrs => addrs.stateId === state.stateId)
                })

                setPrefPMStateList(relatedPrefPMStates)
            }
        })
    }

    const addCompanyRole = () => {
        const newCompanyRoleObj = {
            companyRoleId: uuidv4(),
            companyRoleName: '',
            companyId: id,
            statusId: 1,
            isNew: true
        }
        
        let allEditedCompanyRoles = [...editedCompanyRoles, newCompanyRoleObj]
        setEditedCompanyRoles(allEditedCompanyRoles)
    }

    const deleteCompanyRole = (selectedCompanyRoleId, isNewCompanyRole ) => {
        let relatedCompanyRoleUser = editedCompanyUsers.find(eachCompanyUser => {
            if(eachCompanyUser.userRoles){
                if(eachCompanyUser.userRoles.companyRoleId === selectedCompanyRoleId){
                    return eachCompanyUser
                }
            }
        })
        if(relatedCompanyRoleUser){
            return dispatch(raiseToast({severity:'warn', detail: "CompanyRole cant be removed if there's any active user in it"}))
        }
        let allEditedCompanyRoles = []
        if( selectedCompanyRoleId && isNewCompanyRole){
            const relatedCompanyRole = editedCompanyRoles?.filter(role => role.companyRoleId != selectedCompanyRoleId)
            allEditedCompanyRoles = [...relatedCompanyRole]
        }
        else{
            const relatedCompanyRole = editedCompanyRoles?.find(role => role.companyRoleId === selectedCompanyRoleId)
            if(relatedCompanyRole){
                relatedCompanyRole.statusId = 2
            }

            allEditedCompanyRoles = [...editedCompanyRoles]
        }
        setEditedCompanyRoles(allEditedCompanyRoles)
    }

    const handleCompanyUserDecrement = async(selectedCompanyUserId, isNewCompanyUser, userDetails) => {

        let relatedHODRole = editedCompanyRoles?.find(eachRole => eachRole.companyRoleName === "HOD")
        if(relatedHODRole){
            if(userDetails?.userRoles?.companyRoleId === relatedHODRole.companyRoleId){
                return dispatch(raiseToast({severity:'warn', detail: "Can't delete HOD user. If you want to delete this user, please assign HOD role to other user"}))
            }
        }

        if( selectedCompanyUserId && isNewCompanyUser){
            const relatedCompanyUser = editedCompanyUsers?.filter(eachUser => eachUser.userId != selectedCompanyUserId)
            editedCompanyUsers = [...relatedCompanyUser]
        }
        else{
            const relatedCompanyUser = editedCompanyUsers?.find(eachUser => eachUser.userId === selectedCompanyUserId)
            if(relatedCompanyUser){
                relatedCompanyUser.statusId = 2
            }

            editedCompanyUsers = [...editedCompanyUsers]
        }
        setEditedCompanyUsers([...editedCompanyUsers])
    }

    const handleTextInputChange = (event) => {
        if (event.target.name) {
            if (event.target.name === "prefPMBranchId" && event.target.value === 0 && !prefPMBranchPermissionDetails.isPermitted) {
                return
            }

            if(event.target.name === "buyerSeller"){
                if(editedCompanyDetails?.panCode && editedCompanyDetails?.panCode[3] === "P"){
                    editedCompanyDetails["ownershipTypeId"] = 1
                }else{
                    editedCompanyDetails["ownershipTypeId"] = companyDetails.ownershipTypeId
                }

                if([2, 3].includes(event.target.value)  && !editedCompanyDetails.enableServicePurchase){
                    editedCompanyDetails["tdsSectionId"] = 1
                    if (pmCompanyConfig.isInternational){
                        if (event.target.value === 2){
                            editedCompanyDetails["supplyTypeId"] = null
                        }
                    }
                }else{
                    editedCompanyDetails["tdsSectionId"] = null
                }

                if(companyDetails.buyerSeller === 1 && event.target.value === 3){
                    let relatedCompanyUsers = editedCompanyUsers.filter(eachUser => eachUser?.userRoles?.branchId === 0 && eachUser?.userRoles?.statusId === 1)
                    if(relatedCompanyUsers.length > 0){
                        return dispatch(raiseToast({severity:'warn', detail: "Please assign all users to a specific branch, instead of ALL before proceeding here"}))
                    }
                }

                if (pmCompanyConfig.isInternational){
                    if([1, 3].includes(event.target.value)){
                        editedCompanyDetails["supplyTypeId"] = 1
                    }
                }
            }

            if(event.target.name === "ownershipTypeId"){
                if(editedCompanyDetails.panCode && editedCompanyDetails?.panCode[3] === "P"){
                    if(event.target.value != 1){
                        editedCompanyDetails["ownershipTypeId"] = 1
                        return dispatch(raiseToast({severity:'warn', detail: "For this pancode, ownership should be Sole Sole Proprietorship"}))
                    }
                }else {
                    editedCompanyDetails["ownershipTypeId"] = event.target.value
                }
            }

            if(event.target.name === "panCode"){
                if(event?.target?.value[3] === "P"){
                    editedCompanyDetails["ownershipTypeId"] = 1
                }else{
                    editedCompanyDetails["ownershipTypeId"] = null
                }

                if(editedCompanyGSTIN.length>0){
                    let relatedURDGSTINCode = editedCompanyGSTIN.filter(eachGSTIN => eachGSTIN.gstinCode === "URD" || eachGSTIN.gstinCode === "URP")
                    setEditedCompanyGSTIN([...relatedURDGSTINCode])
                }
    
                if(editedCompanyDetails.gstinCode){
                    editedCompanyDetails['gstinCode'] = ''
                }

                if(isPANVerified){
                    setIsPANVerified(null)
                }
            }

            if(event.target.name === "tdsSectionId"){
                setVisibleSACCode(true)
            }

            editedCompanyDetails[event.target.name] = event.target.value
            
            setEditedCompanyDetails({ ...editedCompanyDetails })
        }
    }
    
    const handleIndustryListOptionDisabled = (category) => {
        return category.optionDisabled
    }

    const handleCompanyAddressChange = (event) => {
        editedCompanyDetails[event.target.name] = event.target.value
        if(event.target.name === "pinCode" && (event.target.value).length === pmCompanyConfig.pinCodeLength ){
            const relatedPinCode = pinCodesData?.find(eachPincode => {
                if(eachPincode.pinCode === parseInt(event.target.value)){
                    return eachPincode
                }
            })

            if((relatedPinCode && relatedPinCode?.stateId) || pmCompanyConfig.isInternational){
                if (!pmCompanyConfig.isInternational){
                    const relatedState = statesDetails?.find(eachState => {
                        if(eachState.stateId === relatedPinCode.stateId){
                            editedCompanyDetails["stateId"] = eachState?.stateId
                            return eachState
                        }
                    })
            
                    initialData?.countryData?.find(eachCountry => {
                        if(eachCountry.countryId === relatedState.countryId){
                            editedCompanyDetails["countryId"] = eachCountry.countryId
                        }
                    })
                } else{
                    companyDetails["stateId"] = pmCompanyConfig.defaultStateId
                    companyDetails["conutryId"] = pmCompanyConfig.defaultCountryId
                }
            }else{
                return dispatch(raiseToast({severity:'warn', detail: "Please enter valid pincode"}))
            }
        }else{
            if(event.target.name === "pinCode"){
                editedCompanyDetails["stateId"] = null
                editedCompanyDetails["countryId"] = null
            }
        }

        if(event.target.name === "countryId"){
            editedCompanyDetails["stateId"] = null
        }
        setEditedCompanyDetails({...editedCompanyDetails})
    }

    const handlePaymentTermsChange = (event) => {
        if (event.target.name) {
            const payment_details = editedCompanyDetails.paymentTerms ? editedCompanyDetails.paymentTerms : {}
            payment_details[event.target.name] = event.target.value
            editedCompanyDetails.paymentTerms = payment_details
            setEditedCompanyDetails({ ...editedCompanyDetails })
        }
    }

    const handleToggleSwitchButtonChange = (event) => {
        if (event.target.name) {
            editedCompanyDetails[event.target.name] = event.target.value
            setEditedCompanyDetails({ ...editedCompanyDetails })
            if (event.target.name == 'enableServicePurchase'){
                editedCompanyDetails["enableServicePurchase"] = event.value
                if(event.value){
                    editedCompanyDetails["tdsSectionId"] = null
                }else{
                    editedCompanyDetails["tdsSectionId"] = 1
                }
                setEditedCompanyDetails({...editedCompanyDetails})
            }
        }
    }

    const handlePaymentTermsOnBlur = (event) => {
        //return

        const isSeller = [2, 3].includes(companyDetails.buyerSeller)
        
        let masterPaymentTerms = {}
        if(companyDetails.paymentTerms){
            masterPaymentTerms = companyDetails.paymentTerms
        }else{
            masterPaymentTerms = {}
        }

        let total_payment_percentage = 0

        if (masterPaymentTerms?.payAdvPO) {
            masterPaymentTerms.payAdvPO = parseFloat(masterPaymentTerms.payAdvPO)
            total_payment_percentage += masterPaymentTerms.payAdvPO
        }
        if (masterPaymentTerms?.payAdvDelivery) {
            masterPaymentTerms.payAdvDelivery = parseFloat(masterPaymentTerms.payAdvDelivery)
            total_payment_percentage += masterPaymentTerms.payAdvDelivery
        }
        if (masterPaymentTerms?.payOnDelivery) {
            masterPaymentTerms.payOnDelivery = parseFloat(masterPaymentTerms.payOnDelivery)
            total_payment_percentage += masterPaymentTerms.payOnDelivery
        }
        if (masterPaymentTerms?.payCredit && masterPaymentTerms?.payCredit != 0) {
            masterPaymentTerms.payCredit = parseFloat(masterPaymentTerms.payCredit)
            total_payment_percentage += masterPaymentTerms.payCredit
        }
        if (masterPaymentTerms?.payPDCDelivery && masterPaymentTerms?.payPDCDelivery != 0) {
            masterPaymentTerms.payPDCDelivery = parseFloat(masterPaymentTerms.payPDCDelivery)
            total_payment_percentage += masterPaymentTerms.payPDCDelivery
        }

        let isPaymentTermsUpdationAllowedWithOutRestriction = false
        if(total_payment_percentage < 100 || companyDetails.statusId === 5 || !isSeller){
            isPaymentTermsUpdationAllowedWithOutRestriction = true
        }

        const paymentDetails = editedCompanyDetails.paymentTerms ? editedCompanyDetails.paymentTerms : {}

        if(event.target.name !== "creditPeriodId"){
            const splittedValue = event.target.value.split('.')

            if (splittedValue.length > 1) {
                if(splittedValue[1].length > 2){
                    return false
                }
            }
        } else {
            let {isPermitted} = checkPermissions({...userDetails, permissions: [114]})

            if(isPaymentTermsUpdationAllowedWithOutRestriction){
                isPermitted = true
            }

            if(!isPermitted){
                const previousCreditPeriodId = masterPaymentTerms.creditPeriodId ? parseInt(masterPaymentTerms.creditPeriodId) : 0
                const previoudCreditPeriod = initialData.companyCreditPeriodsData.find(obj => obj.creditPeriodId === previousCreditPeriodId)

                if(previousCreditPeriodId > parseInt(event.target.value)){
                    return dispatch(raiseToast({severity:'error', detail: `Credit period should not be less than previous value ${previoudCreditPeriod?.creditPeriodName}`}))
                }
            }
            paymentDetails.creditPeriodId = parseInt(event.target.value)
            editedCompanyDetails.paymentTerms = paymentDetails
            setEditedCompanyDetails({ ...editedCompanyDetails })
            return 
        }

        if(event.target.value >= 0){
            let {isPermitted} = checkPermissions({...userDetails, permissions: [114]})

            if(isPaymentTermsUpdationAllowedWithOutRestriction){
                isPermitted = true
            }

            if(!isPermitted){
                let paymentTermNames = ['payAdvPO', 'payAdvDelivery', 'payPDCDelivery', 'payOnDelivery', 'payCredit']

                let paymentTermShortName = event.target.name
                let previousValue = masterPaymentTerms[paymentTermShortName]
                
                let masterPaymentTermsPercentagesArr = []
                paymentTermNames.map(termName => {
                    let percentage = masterPaymentTerms[termName]
                    if(percentage){
                        masterPaymentTermsPercentagesArr.push(percentage)
                    } else {
                        masterPaymentTermsPercentagesArr.push(0)
                    }
                })

                let availablePaymentPercentage = 0
                let previousTermExist = false 

                let currentPaymentTermIndex = paymentTermNames.findIndex(term => {
                    if(event.target.name === term){
                        return true
                    }
                    return false
                })

                masterPaymentTermsPercentagesArr.map((termPercentage, index) => {
                    if(index <= currentPaymentTermIndex){
                        availablePaymentPercentage += termPercentage
                        availablePaymentPercentage = parseFloat(parseFloat(availablePaymentPercentage).toFixed(2))
                        if(index < currentPaymentTermIndex){
                            previousTermExist = true
                        }
                    }
                })

                if(event.target.name === 'payAdvPO'){
                    if(parseFloat(event.target.value) > previousValue){
                        paymentDetails[event.target.name] = previousValue
                        dispatch(raiseToast({severity:'error', detail: `Adv against PO cant be greater than previous value ${previousValue}`}))
                    }
                }else if(event.target.name === 'payAdvDelivery'){
                    if(parseFloat(event.target.value) > availablePaymentPercentage){
                        paymentDetails[event.target.name] = availablePaymentPercentage
                        dispatch(raiseToast({severity:'error', detail: `Adv before Delivery cant be greater ${availablePaymentPercentage}`}))
                    }
                } else if(event.target.name === 'payPDCDelivery'){
                    if(parseFloat(event.target.value) > availablePaymentPercentage){
                        paymentDetails[event.target.name] = availablePaymentPercentage
                        dispatch(raiseToast({severity:'error', detail: `PDC on Delivery cant be greater than ${availablePaymentPercentage}`}))
                    }
                } else if(event.target.name === 'payOnDelivery'){
                    if(parseFloat(event.target.value) > availablePaymentPercentage){
                        paymentDetails[event.target.name] = availablePaymentPercentage
                        dispatch(raiseToast({severity:'error', detail: `Pay against Delivery cant be greater than ${availablePaymentPercentage}`}))
                    }
                } else if(event.target.name === 'payCredit'){
                    if(parseFloat(event.target.value) < previousValue){
                        paymentDetails[event.target.name] = previousValue
                        dispatch(raiseToast({severity:'error', detail: `Credit cant be less than previous value ${previousValue}`}))
                    }
                }
            }
            editedCompanyDetails.paymentTerms = paymentDetails
            setEditedCompanyDetails({ ...editedCompanyDetails })
        }
    }

    const handleMSMEDChange = (event) => {
        
        if (event.value === "Registered") {
            editedCompanyDetails['isMSMEDRegd'] =  true
        }
        else {
            editedCompanyDetails['isMSMEDRegd'] = false
        }

        if(editedCompanyDetails.paymentTerms.creditPeriodId){
            let relatedCreditPeriod = initialData.companyCreditPeriodsData.find(obj => obj.creditPeriod >= 45 && obj.creditPeriodId === editedCompanyDetails.paymentTerms.creditPeriodId)
            if(relatedCreditPeriod){
                delete editedCompanyDetails.paymentTerms.creditPeriodId
            }
        }

        if(event.value !== "Registered"){
            editedCompanyDetails.companyMSMEDTypeId = null
        }

        editedCompanyDetails.msmedCert = ''
        setEditedCompanyDetails({ ...editedCompanyDetails })
    }

    const handleCompanyRoleChange = (event, selectedCompanyRoleId) => {
        let relatedCompanyRole = editedCompanyRoles?.find(role => role.companyRoleId === selectedCompanyRoleId)
        if (relatedCompanyRole) {
            relatedCompanyRole.companyRoleName = event.target.value
        }

        let updatedCompanyRoles = [...editedCompanyRoles]
        setEditedCompanyRoles(updatedCompanyRoles)
    }

    const handleCompanyRoleInputBlur = (event, selectedCompanyRoleId) => {

        let relatedCompanyRole = editedCompanyRoles.find(role => role.companyRoleId === selectedCompanyRoleId);

        if (relatedCompanyRole) {
            const inputRoleName = event.target.value?.trim().toLowerCase();

            const isRoleNameExists = editedCompanyRoles.some(role => role.companyRoleId !== selectedCompanyRoleId && role.companyRoleName.toLowerCase() === inputRoleName);

            if (isRoleNameExists) {
                relatedCompanyRole.companyRoleName = '';
                dispatch(raiseToast({ severity: 'warn', detail: 'Company role already exists', life: 3000 }));
            } else {
                relatedCompanyRole.companyRoleName = inputRoleName.toUpperCase();
            }
        }

        setEditedCompanyRoles([...editedCompanyRoles])
    }

    const handleCompanyUserChange = (event, selectedCompanyUserId) => {
        const relatedCompanyUser = editedCompanyUsers?.find(eachUser => eachUser.userId === selectedCompanyUserId)
        const relatedCompanyRole = editedCompanyRoles?.find(eachRole => eachRole.companyRoleId === event.target.value)
        if (relatedCompanyUser) {
            if(event.target.name === "companyRoleId"){
                if (id == 1){
                    let {isPermitted} = checkPermissions({ ...userDetails, permissions: [147] })
                    if (isPermitted){
                        //userRole[event.target.name] = event.target.value
                    }else if ([2, 11, 48425, 61270, 61269, 61268].includes(event.target.value)){
                        //userRole[event.target.name] = event.target.value
                    }else{
                        return dispatch(raiseToast({severity:'error', detail:`Selected User Role Can't be Assigned.`, life: 3000}))
                    }
                }
                if(relatedCompanyUser.userRoles){
                    relatedCompanyUser.userRoles[event.target.name] = event.target.value
                    relatedCompanyUser.userRoles["companyRoleName"] = relatedCompanyRole?.companyRoleName
                }
                else{
                    let userRoles = {
                        userId: relatedCompanyUser.userId,
                        companyId: id,
                        companyRoleId: event.target.value,
                        companyRoleName: relatedCompanyRole?.companyRoleName
                    }
                    relatedCompanyUser.userRoles = userRoles
                }
            }else{
                relatedCompanyUser[event.target.name] = event.target.value
                relatedCompanyUser.userRoles["companyRoleName"] = relatedCompanyRole?.companyRoleName
            }
        }

        setEditedCompanyUsers([...editedCompanyUsers])
    }

    const handleAddUserCompanyRole = async (event) => {
        setUserName(event.value)
        let selectedUserId = event?.value?.userId
        let relatedCompanyUser = companyUsers.find(user => user.userId === selectedUserId) //event.target.value)
        let relatedEditedCompanyUser = editedCompanyUsers?.find(user => user.userId === selectedUserId) //event.target.value )

        if(relatedEditedCompanyUser){
            if(relatedEditedCompanyUser.statusId === 2){
                relatedEditedCompanyUser.statusId = 1
                if(!relatedEditedCompanyUser.userRoles){
                    relatedEditedCompanyUser.userRoles = {
                        userRoleId: uuidv4(),
                        userId: relatedCompanyUser.userId,
                        companyId: id,
                        companyRoleId: '',
                        branchId: 0,
                        isNew: true,
                    }
                }else{
                    relatedEditedCompanyUser.userRoles.branchId = 0
                    relatedEditedCompanyUser.userRoles.statusId = 1
                }
                
                setEditedCompanyUsers([...editedCompanyUsers])
                setUserName(null)
            }else{
                setUserName(null)
                return dispatch(raiseToast({ severity: 'warn', detail: "User already added", life: 3000 }))
            }
        }else{
            if(relatedCompanyUser){
                let relatedCompanyUserandUserRole = {...relatedCompanyUser}
                relatedCompanyUserandUserRole.statusId = 1
                if(!relatedCompanyUserandUserRole.userRoles){
                    relatedCompanyUserandUserRole.userRoles = {
                        userRoleId: uuidv4(),
                        userId: relatedCompanyUser.userId,
                        companyId: id,
                        companyRoleId: '',
                        branchId: 0,
                        isNew: true
                    }
                }else{
                    relatedCompanyUserandUserRole.userRoles.branchId = 0
                    relatedCompanyUserandUserRole.userRoles.statusId = 1
                }
            
                setUserName(null)
                setEditedCompanyUsers([...editedCompanyUsers, JSON.parse(JSON.stringify(relatedCompanyUserandUserRole))])
            }
        }
    }

    const fileUploadHandler = async ({ files, options }, doc_name) => {
        const { fileArr, error, errorMsg } = await getUploadedFileObj({ files, options, documentName: doc_name })
        if (error) {
            return dispatch(raiseToast({ severity: 'error', detail: errorMsg, life: 3000 }))
        }
        const fileObj = fileArr[0]
        uploadCompanyRelatedCertificates(doc_name, fileObj.name, fileObj.dataURI , fileObj.inputName)
    }

    const uploadCompanyRelatedCertificates = async (doc_name, file_name, data_uri, input_name) => {

        let data = {
            doc_name,
            file_name,
            data_uri,
            objectURL: data_uri
        }
        setIsLoading(true)
        let response = await uploadFile(data)
        console.log("upload-file-response", response)
        setIsLoading(false)
        if (response) {
            console.log("input_name", input_name)
            editedCompanyDetails[input_name] = response.data
            setEditedCompanyDetails({ ...editedCompanyDetails })
        }
    }

    const removeCompanyRelatedCertificates = (certificateName) => {
        delete editedCompanyDetails[certificateName]
        setEditedCompanyDetails({ ...editedCompanyDetails })
    }

    const handleDiscardCompanyDetails = () => {
        if(window.confirm("Are you sure you want to discard the changes")){
            setIsEditing(false)
            setEditedCompanyDetails({...companyDetails})
            setEditedCompanyGSTIN([...companyGSTIN])
            setEditedCompanyRoles([...companyRoles])
            setEditedCompanyBillAddrs([...companyBillAddrs])
        }
    }

    const handleSubmitBllAddr = async (billAddrObj) => {
        setEditedCompanyBillAddrs(prevState => ([...prevState, billAddrObj]))
        setVisibleAddNewBillingAddr(false)
    }

    const getCompanyGstinList = async (data) => {

        const companyGSTINsRes = await getCompanyGSTINs({ ...data })
        if (companyGSTINsRes.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: companyGSTINsRes.data.error, life: 3000 }))
        }

        if (companyGSTINsRes?.data?.data?.length > 0) {
            let sortedGSTINs = sortArrayOfObjectsInAlphabeticalOrder(companyGSTINsRes.data.data, "gstinCode")
            sortedGSTINs = sortedGSTINs.filter(eachGSTINs => eachGSTINs.gstinCode)

            // setGSTINs(sortedGSTINs)
            setCompanyGSTIN(sortedGSTINs)
            setEditedCompanyGSTIN(JSON.parse(JSON.stringify(sortedGSTINs)))
        }
    }
    
    const getVerifyGSTINsStatus = async (companyId) => {
        try {
            const response = await getCompanyProcessStatus(companyId)
            if (response.data.lastGSTINsVerificationStatus === 'PROCESSING') {
                setTimeout(() => getVerifyGSTINsStatus(companyId), 5000)
            } else if (response.data.lastGSTINsVerificationStatus === 'COMPLETED') {
                getCompanyGstinList({ companyIds: [companyId], paginator: false, sortBy: 'gstinCode' })
                dispatch(raiseToast({ severity: 'success', detail: `GSTINs are updated successfully.`, life: 5000 }))
            } else if (response.data.lastGSTINsVerificationStatus === 'FAILED') {
                dispatch(raiseToast({ severity: 'error', detail: `Upload failed: ${response.data.lastGSTINsVerificationError || 'Unknown error'}`, life: 5000 }))
            }
        } catch (error) {
            console.error('Error polling upload status:', error)
            dispatch(raiseToast({ severity: 'error', detail: 'Error checking upload status', life: 3000 }))
        }
    }

    const handleVerifyClick = async () => {
        // setIsLoading(true)
        // setIsGSTINDataLoading(true)

        const companyGSTINsRes = await verifyCompanyGSTINs({ panCode: editedCompanyDetails.panCode, companyId: editedCompanyDetails.companyId })
        if (companyGSTINsRes.failure) {
            setIsPANVerified(true)
            setEditedCompanyGSTIN([...editedCompanyGSTIN])
            setIsGSTINDataLoading(false)
            setIsLoading(false)
            if (companyGSTINsRes.data.error === 'UPLOAD_IN_PROGRESS') {
                dispatch(raiseToast({ severity: 'error', detail: 'GSTIN verification is already in progress. Please wait for it to complete.', life: 3000 }))
            }
            return dispatch(raiseToast({ severity: 'error', summary: 'Company GSTINs', detail: companyGSTINsRes.data.error, life: 3000 }))
        }

        dispatch(raiseToast({ severity: 'info', detail: 'GSTIN verification has started. You will be notified once it is complete.', life: 5000 }))
        getVerifyGSTINsStatus(id)

        // setGSTINs(companyGSTINsRes.data)
        // setEditedCompanyGSTIN(companyGSTINsRes.data)
        // setCompanyGSTIN(companyGSTINsRes.data)
        setIsPANVerified(true)

        // setIsLoading(false)
        // setIsGSTINDataLoading(false)
    }

    const companyUsersSearchMethod = (event) => {
        const relatedCompanyUsers = companyUsers.filter(eachUser => eachUser.fullName.toLowerCase().includes(event.query.trim().toLowerCase()))
        if (relatedCompanyUsers.length > 0) {
            setCompanyUsersSuggestions(relatedCompanyUsers)
        }else{
            setCompanyUsersSuggestions([])
        }
    }

    const searchClientSuccessManagers = (event) => {
        const relatedClientSuccessManagers = clientSuccessManagers.filter(eachUser => eachUser.fullName.toLowerCase().includes(event.query.trim().toLowerCase()))
        setSearchedClientSuccessManagers([...relatedClientSuccessManagers])
    }

    const dispalyApproverDetails = (allApprovers) => {
        let approverNames = []
        allApprovers.map(eachApprover => {
            approverNames.push(eachApprover.fullName)
        })
        return approverNames.join(", ")
    }

    const getApprovarDetailsData = (relatedApproval, pm_branch_id) => {
        const pmCompanyUsers = userDetails?.PMCompanyDetails?.companyUsers ? userDetails?.PMCompanyDetails?.companyUsers : []
        const pmCompanyRoles = userDetails?.PMCompanyDetails?.companyRoles ? userDetails?.PMCompanyDetails?.companyRoles : []
        const pmBranches = userDetails?.PMCompanyDetails?.companyBranches ? userDetails?.PMCompanyDetails?.companyBranches : []

        const pmBranchId = pm_branch_id ? pm_branch_id : null
        const createdBy = null
        if(relatedApproval){
            const approvalDetails = getApproverDetails(relatedApproval, pmBranchId, createdBy, pmCompanyUsers, pmCompanyRoles, pmBranches, approvalSecondary)
            return approvalDetails
        } else {
            return []
        }
    }

    const renderApprovalDetailsDisplay = (relatedApprovalInstance, brandId, brandName) => {
        let approvalInstanceStatus = statusList.find((status) => status.statusId == relatedApprovalInstance.statusId)?.status
        const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === relatedApprovalInstance.approvalId)

        let approvalRequestType = ""
        let approvalDesc = ""
        let tooltipName = ""

        if (relatedApproval.approvalTypeId === 18) {
            approvalRequestType = "Requested TDS Type"
            tooltipName = "tds"
            let relatedTDSSection = tdsSections.find(eachTDS =>  eachTDS.tdsSectionId === relatedApprovalInstance.approvedMetrics?.tdsSectionId)
            if (relatedTDSSection) {
                approvalDesc = relatedTDSSection.tdsSectionName
                if (relatedTDSSection.tdsSectionName !== "No TDS") {
                    approvalDesc = `${relatedTDSSection.tdsSectionName} (${relatedTDSSection.tdsSectionDesc})`
                }
            }
        } 
        else if (relatedApproval.approvalTypeId === 19) {
            let approvalPaymentTerms = {}
            if(relatedApprovalInstance.approvedMetrics.paymentTerms){
                approvalPaymentTerms = relatedApprovalInstance.approvedMetrics.paymentTerms
            }
            
            approvalRequestType = "Requested payment terms"
            tooltipName = "payment-terms"
            approvalDesc = ""

            if(approvalPaymentTerms.payAdvPO){
                approvalDesc += `Adv against PO (%): ${approvalPaymentTerms.payAdvPO},\n`
            }

            if(approvalPaymentTerms.payAdvDelivery){
                approvalDesc += `Adv before Delivery (%): ${approvalPaymentTerms.payAdvDelivery},\n`
            }

            if(approvalPaymentTerms.payPDCDelivery){
                approvalDesc += `PDC on Delivery (%): ${approvalPaymentTerms.payPDCDelivery},\n`
            }

            if(approvalPaymentTerms.payOnDelivery){
                approvalDesc += `Pay against Delivery (%): ${approvalPaymentTerms.payOnDelivery},\n`
            }

            if(approvalPaymentTerms.payCredit){
                approvalDesc += `Credit (%): ${approvalPaymentTerms.payCredit},\n`
            }

            let relatedCreditPeriod = null
            if(approvalPaymentTerms.creditPeriodId){
                relatedCreditPeriod = initialData.companyCreditPeriodsData.find(eachCreditPeriod => eachCreditPeriod.creditPeriodId === approvalPaymentTerms.creditPeriodId)
                if(relatedCreditPeriod){
                    approvalDesc += `Credit Period: ${relatedCreditPeriod.creditPeriodName}`
                }
            }
        } else if (relatedApproval.approvalTypeId === 25) {
            approvalRequestType = "Requested Company onboarding"
            approvalDesc = "Fully onboarding"
            const relatedCompanyRole = pmCompanyDetails.companyRoles.map(eachRole => eachRole.companyRoleId === relatedApproval.primaryApprover)
            if (relatedCompanyRole?.companyRoleId === 13) {
                tooltipName = "company_onboarding_regional_head"
                approvalRequestType += " - Regional Head (Level 1)"
            } else if (relatedCompanyRole?.companyRoleId === 9) {
                tooltipName = "company_onboarding_data_ops"
                approvalRequestType += " - Data Ops (Level 2)"
            }
        } 
        else if (relatedApproval.approvalTypeId === 27) {
            approvalRequestType = "Requested payment mode"
            tooltipName = "preferred_payment_mode"
            approvalDesc = relatedApprovalInstance.approvedMetrics.preferredPaymentMode
        }
        else if (relatedApproval.approvalTypeId === 43) {
            approvalRequestType = `Requested Brand Certificate Approval`
            tooltipName = `${brandId}_brand_approval`
            approvalDesc = brandName
        }
        
        let approvalDetails = getApprovarDetailsData(relatedApproval)
        
        return (
            <div className="flex justify-content-end py-0">
                <Tooltip target={`.custom-tool-tip-company-${tooltipName}-approval-status${id}`} position="top" autoHide >
                    <p className='m-0'><b>{approvalRequestType}: </b>  {approvalDesc} </p>
                    <p className='m-0'><b>Approver:</b>  {dispalyApproverDetails(approvalDetails)} </p>
                    <p className='m-0'><b>Status:</b>  {approvalInstanceStatus} </p>
                    { pmCompanyConfig.companyApprovalTypeIds.includes(relatedApproval.approvalTypeId) && approvalInstanceStatus === "REJECTED" ? <p className='m-0'><b>Remarks: </b>  {relatedApprovalInstance.processedRemarks} </p> : ""}
                </Tooltip>
                <img src="https://procmart-dev.s3.ap-south-1.amazonaws.com/requirementSourceDocument/0370048a-e0db-4fa2-9ef9-ab84df0af52a.png" className={`text-xs mb-1 mr-2 custom-tool-tip-company-${tooltipName}-approval-status${id} cursor-auto`} style={{ height: "35px", width: "30px", marginTop:"10px"}} />
            </div>
        )
    }

    const renderOnboardingApprovalDetailsDisplay = (regionalHeadInstance, dataOpsInstance) => {
        const approvalRequestType = "Requested Company onboarding"
        const approvalDesc = "Fully onboarding"
        const tooltipName = `custom-tooltip-company-onboarding-approval-status${id}`

        const getStatusText = (statusId) => statusList.find(s => s.statusId === statusId)?.status

        const renderApprovalLevel = (label, instance) => {
            const approval = approvals.find(app => app.approvalId === instance.approvalId)
            const approverDetails = getApprovarDetailsData(approval, instance.pmBranchId)

            return (
                <>
                    <hr className='my-2' />
                    <p className='m-0 font-bold'>{label}</p>
                    <p className='m-0'><b>Approver:</b> {dispalyApproverDetails(approverDetails)}</p>
                    <p className='m-0'><b>Status:</b> {getStatusText(instance.statusId)}</p>
                    {instance.statusId === 8 && (
                        <p className='m-0'><b>Remarks:</b> {instance.processedRemarks}</p>
                    )}
                </>
            )
        }

        return (
            <div className="flex justify-content-end py-0">
                <Tooltip target={`.${tooltipName}`} position="top" autoHide>
                    <p className='m-0'><b>{approvalRequestType}: </b>  {approvalDesc} </p>
                    {regionalHeadInstance && renderApprovalLevel("Regional Head (Level 1)", regionalHeadInstance)}
                    {dataOpsInstance && renderApprovalLevel("Data Ops (Level 2)", dataOpsInstance)}
                </Tooltip>
                <img
                    src="https://procmart-dev.s3.ap-south-1.amazonaws.com/requirementSourceDocument/0370048a-e0db-4fa2-9ef9-ab84df0af52a.png"
                    className={`text-xs mb-1 mr-2 ${tooltipName} cursor-auto`}
                    style={{ height: "35px", width: "30px", marginTop: "10px" }}
                />
            </div>
        )
    }
    
    const searchCompanyGroupTypes = (event) => {
        const relatedCompanygroups = initialData?.companyGroupsData.filter(group => group.groupName.toLowerCase().startsWith(event.query.trim().toLowerCase()))
        if(relatedCompanygroups.length > 0){
            return setRelatedCompanyGroupTypes(relatedCompanygroups);
        }setRelatedCompanyGroupTypes(["this is empty"])
    }

    const handlePreferredPaymentModeChange = (event) => {
        const updatedCompanyDetails = { ...editedCompanyDetails, preferredPaymentMode: event.value }

        setEditedCompanyDetails({ ...updatedCompanyDetails })
    }

    const handlePaymentTermsApproval = (paymentTerms, masterPaymentTerms) => {
        
        if(!paymentTerms){
            paymentTerms = {
                payAdvPO: 0,
                payAdvDelivery: 0,
                payPDCDelivery: 0,
                payOnDelivery: 0,
                payCredit: 0,
                creditPeriodId: 0
            }
        }
        if(!masterPaymentTerms){
            masterPaymentTerms = {
                payAdvPO: 0,
                payAdvDelivery: 0,
                payPDCDelivery: 0,
                payOnDelivery: 0,
                payCredit: 100,
                creditPeriodId: 10
            }
        }
        
        const isApprovalReq = Object.keys(paymentTerms).some(eachPaymentTerm => {
            if (eachPaymentTerm === 'creditPeriodId') {
                const previousCreditPeriodId = masterPaymentTerms.creditPeriodId ? parseInt(masterPaymentTerms.creditPeriodId) : 0
                if (previousCreditPeriodId > parseInt(paymentTerms[eachPaymentTerm])) {
                    return true
                }
            }
            else if (eachPaymentTerm !== "creditPeriodId" && paymentTerms[eachPaymentTerm] >= 0) {
                let paymentTermNames = ['payAdvPO', 'payAdvDelivery', 'payPDCDelivery', 'payOnDelivery', 'payCredit']

                let paymentTermShortName = eachPaymentTerm
                let previousValue = masterPaymentTerms[paymentTermShortName]

                let masterPaymentTermsPercentagesArr = []
                paymentTermNames.map(termName => {
                    let percentage = masterPaymentTerms[termName]
                    if (percentage) {
                        masterPaymentTermsPercentagesArr.push(percentage)
                    } else {
                        masterPaymentTermsPercentagesArr.push(0)
                    }
                })

                let availablePaymentPercentage = 0
                let previousTermExist = false

                let currentPaymentTermIndex = paymentTermNames.findIndex(term => {
                    if (eachPaymentTerm === term) {
                        return true
                    }
                    return false
                })

                masterPaymentTermsPercentagesArr.map((termPercentage, index) => {
                    if (index <= currentPaymentTermIndex) {
                        availablePaymentPercentage += termPercentage
                        availablePaymentPercentage = parseFloat(parseFloat(availablePaymentPercentage).toFixed(2))
                        if (index < currentPaymentTermIndex) {
                            previousTermExist = true
                        }
                    }
                })

                if (eachPaymentTerm === 'payAdvPO') {
                    if (parseFloat(paymentTerms[eachPaymentTerm]) > previousValue) {
                        return true
                    }
                } else if (eachPaymentTerm === 'payAdvDelivery') {
                    if (parseFloat(paymentTerms[eachPaymentTerm]) > availablePaymentPercentage) {
                        return true
                    }
                } else if (eachPaymentTerm === 'payPDCDelivery') {
                    if (parseFloat(paymentTerms[eachPaymentTerm]) > availablePaymentPercentage) {
                        return true
                    }
                } else if (eachPaymentTerm === 'payOnDelivery') {
                    if (parseFloat(paymentTerms[eachPaymentTerm]) > availablePaymentPercentage) {
                        return true
                    }
                } else if (eachPaymentTerm === 'payCredit') {
                    if (parseFloat(paymentTerms[eachPaymentTerm]) < previousValue) {
                        return true
                    }
                }
            }
        })

        return isApprovalReq
    }

    const companyGSTINOptionTemplate = (option) => {
        let lineItemColor = ``
        if ([2, 20].includes(option.statusId)) {
            lineItemColor = `#F1592A`
        }
        else if ([21, 22].includes(option.statusId)) {
            lineItemColor = `#cfbf32`
        }
        else {
            lineItemColor = `#13A89D`
        }

        let labelText = ``
        if(option.gstinTradeName){
            labelText = `${option.gstinCode}${option.statusId === 20 ? ' ᵇˡᵃᶜᵏˡᶦˢᵗᵉᵈ ' : ''}${option.exemptedSEZ ? ' ˢᵉᶻ ' : ''} - ${option.gstinTradeName}`
        }
        else{
            labelText = `${option.gstinCode}${option.statusId === 20 ? ' ᵇˡᵃᶜᵏˡᶦˢᵗᵉᵈ ' : ''}${option.exemptedSEZ ? ' ˢᵉᶻ ' : ''}`
        }

        return(
            <>
                <span className="" style={{color: lineItemColor}}>{labelText}</span>
            </>
        )
    }

    const handleGetGoogleUserChatUri = async (approvalEmail) => {
        if (!approvalEmail) {
            return dispatch(raiseToast({ severity: 'error', detail: "Approval user not found. Please contact tech team", life: 3000 }))
        }
        let data = {
            userId: userDetails.userId,
            emailId: approvalEmail
        }

        setIsLoading(true)
        const getGoogleUserChatUriRes = await getGoogleUserChatUri(data)
        setIsLoading(false)

        if (getGoogleUserChatUriRes.failure) {
            if (window.confirm("Chat with the user doesn't exist.\nPlease open chat manually, and send the message.")) {
                window.open("https://mail.google.com/mail/u/0/?tab=rm&ogbl#chat/home", '_blank')
            }
        } else {
            window.open(getGoogleUserChatUriRes.data, '_blank')
        }
    }

    const getAddTagsOptions = (tagsConfig, tagOptions, addTagOption) => {
        const addFilterOptions = []
        tagsConfig.map(eachConfig => {
            const optionExists = tagOptions.some(eachOption => {
                if (eachOption.companyTagId === eachConfig.companyTagId) {
                    return true
                }
            })
    
            if (!optionExists) {
                addFilterOptions.push({
                    label: eachConfig.tagLabel,
                    command: () => {
                        addTagOption(eachConfig.companyTagId)
                    }
                })
            }
        })
    
        return addFilterOptions
    }

    const addTagOption = (companyTagId) => {
        let relatedConfig = tagsConfig.find(eachConfig => eachConfig.companyTagId === companyTagId)
        if(relatedConfig && relatedConfig.tagType?.toLowerCase() === "boolean"){
            setTagOptions([...tagOptions, {...relatedConfig, tagValue: false}])
        }else{
            setTagOptions([...tagOptions, relatedConfig])
        }
    }

    const handleRemoveTags = (selectedCompanyTagId) => {
        setSelectedCompanyTagId(selectedCompanyTagId)
        setIsConfirmTagDeleteDialogVisible(true)
    }

    const handleOnChangeTagValue = (event, selectedCompanyTagId) => {
        let updatedTagOptions = tagOptions.map(eachTag => {
            if(eachTag.companyTagId === selectedCompanyTagId){
                return {...eachTag, tagValue: event.target.value}
            }
            return {...eachTag}
        })
        setTagOptions([...updatedTagOptions])
    }

    const handleCloseConfirmTagDeleteDialog = () => {
        setSelectedCompanyTagId(null)
        setIsConfirmTagDeleteDialogVisible(false)
    }

    const handleConfirmDeleteTag = () => {
        const relatedSearchOption = tagOptions.filter(eachOption => eachOption.companyTagId !== selectedCompanyTagId)
        setTagOptions([...relatedSearchOption])
        setSelectedCompanyTagId(null)
        setIsConfirmTagDeleteDialogVisible(false)
    }

    const entityBody = (row) => {
        if (row.entityId?.brandName) {
            let latestBrandCertificateApprovalInstance = null
            if (brandCertificateApprovalInstanceData.length > 0) {
                let relatedBrandCertificateApprovalInstances = brandCertificateApprovalInstanceData.filter(eachInstance => eachInstance.referenceId === row.entityId.brandId)
                let sortedBrandCertificateApprovalInstancesByDate = sortArrayOfObjectsInAscendingDateOrder(relatedBrandCertificateApprovalInstances, "createdAt", "DESC")
                if (sortedBrandCertificateApprovalInstancesByDate) {
                    latestBrandCertificateApprovalInstance = sortedBrandCertificateApprovalInstancesByDate[0]
                }
            }
            return (
                <div className='flex justify-content-center align-items-center'>
                    <p style={{ cursor: "pointer", padding: "0px", margin: "0px" }}>{row.entityId.brandName}</p>
                    {
                        row.statusId !== 1 && latestBrandCertificateApprovalInstance && [8, 12].includes(latestBrandCertificateApprovalInstance?.statusId) ? renderApprovalDetailsDisplay(latestBrandCertificateApprovalInstance, row.entityId.brandId, row.entityId.brandName) : null
                    }
                </div>
            )
        }
        return "-"
    }

    const issuedDateBody = (row) => {
        const issuedDateStr = getDateString(row.issuedDate)
        return (
            <div>
                <div className='m-0'>{`${issuedDateStr}`}</div>
            </div>
        )
    }

    const expiryDateBody = (row) => {
        const expiryDateStr = getDateString(row.expiryDate)
        return (
            <div>
                <div className='m-0'>{`${expiryDateStr}`}</div>
            </div>
        )
    }

    const brandCertificateDocProofBody = (row) => {
        if(row.docProof){
            return <FileViewAndRemove doc={{url: row.docProof}} docName="docProof" />
        }
        return "-"
    }

    const handleRemoveBrandCertificateDoc = (row) => {
        let updatedBrandCertificate = {...brandCertificate, docProof: null}
        setBrandCertificate(updatedBrandCertificate)
    }

    const handleOnClickEditBrandCertificateBody = (row) => {
        setBrandCertificate({...row})
        setVisibleAddBrandCertificate(true)
    }

    const editBrandCertificateBody = (row) => {
        
        let isBrandEditDisabled = true
        if (isEditing) {
            if (row.statusId === 1) {
                const brandCertificateExpiryDays = moment(new Date(row.expiryDate)).diff(moment(new Date()), 'days')
                if (brandCertificatesPermissionDetails.isPermitted || brandCertificateExpiryDays < 15) {
                    isBrandEditDisabled = false
                }
            } else {
                isBrandEditDisabled = false
            }
        }
        
        return (
            <div className="">
                <span className="edit-btn">
                    <Button className="edit-btn-icon p-0" icon="pi pi-user-edit" text onClick={() => handleOnClickEditBrandCertificateBody(row)} size="small" disabled={isBrandEditDisabled} />
                </span>
            </div>
        )
    }

    const deleteBrandCertificateBody = (row) => {
        
        return (
            <div className="">
                <span className="decrement-btn">
                    <Button className="decrement-btn-icon p-0" icon="pi pi-minus-circle" text onClick={() => handleRemoveBrandCertificate(row)} size="small" disabled={!isEditing || row.statusId === 1 } />
                </span>
            </div>
        )
    }

    const brandCertificatesTableColumns = [
        {
            header: 'Entity Type',
            field: '',
            body: entityBody,
        },
        {
            header: 'Issued Date',
            field: 'phoneNumber',
            body: issuedDateBody
        },
        {
            header: 'Expirty Date',
            field: 'emailId',
            body: expiryDateBody
        },
        {
            header: 'Brand Certificate',
            field: '',
            body: brandCertificateDocProofBody
        },
        {
            header: 'Edit',
            field: '',
            body: editBrandCertificateBody
        },
        {
            header: 'Delete',
            field: '',
            body: deleteBrandCertificateBody
        }
    ]

    const searchBrands = (event) => {
        const relatedBrands = materialBrands.filter(brand => brand.brandName?.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedMaterialBrands([...relatedBrands])
    }

    const handleBrandCertificateInputChange = (event) => {
        brandCertificate[event.target.name] = event.target.value
        setBrandCertificate({ ...brandCertificate })
    }

    const handleRemoveBrandCertificate = (selectedBrandCertificate) => {
        if (selectedBrandCertificate.isNew) {
            const relatedBrandCertificates = brandCertificates.filter(eachCertificate => eachCertificate.brandCertificateId !== selectedBrandCertificate.brandCertificateId)
            setBrandCertificates([...relatedBrandCertificates])
        } else {
            let updatedBrandCertificates = brandCertificates.map(eachBrandCertificate => {
                if (eachBrandCertificate.brandCertificateId === selectedBrandCertificate.brandCertificateId) {
                    return { ...eachBrandCertificate, statusId: 2 }
                }
                return { ...eachBrandCertificate }
            })
            setBrandCertificates([...updatedBrandCertificates])
        }
    }

    const handleSubmitBrandCertificate = () => {
        if (!brandCertificate.entityId) {
            return dispatch(raiseToast({ severity: 'error', detail: `Please select brand`, life: 3000 }))
        }
        if (!brandCertificate.issuedDate) {
            return dispatch(raiseToast({ severity: 'error', detail: `Please select issued date`, life: 3000 }))
        }
        if (!brandCertificate.expiryDate) {
            return dispatch(raiseToast({ severity: 'error', detail: `Please select expirty date`, life: 3000 }))
        }
        if (brandCertificate.entityId && brandCertificate.entityId?.config?.certificateProofMandatory && !brandCertificate.docProof) {
            return dispatch(raiseToast({ severity: 'error', detail: `Please upload brand certificate`, life: 3000 }))
        }
        if (!brandCertificate.remarks || !brandCertificate.remarks?.trim()) {
            return dispatch(raiseToast({ severity: 'error', detail: `Please enter remarks`, life: 3000 }))
        }else{
            brandCertificate.remarks = brandCertificate.remarks.trim()
        }

        const duplicateBrandCertificate = brandCertificates.find(eachBrandCertificate => eachBrandCertificate.entityId.brandId === brandCertificate.entityId.brandId && eachBrandCertificate.brandCertificateId !== brandCertificate.brandCertificateId)
        if (duplicateBrandCertificate) {
            return dispatch(raiseToast({ severity: 'error', detail: `Brand ${duplicateBrandCertificate.entityId.brandName} is already added.`, life: 3000 }))
        }

        const relatedBrandCertificate = brandCertificates.find(eachBrandCertificate => eachBrandCertificate.brandCertificateId === brandCertificate.brandCertificateId)
        if(relatedBrandCertificate){
            let updatedBrandCertificates = brandCertificates.map(eachBrandCertificate => {
                if(eachBrandCertificate.brandCertificateId === brandCertificate.brandCertificateId){
                    return { ...brandCertificate}
                }
                return {...eachBrandCertificate}
            })
            setBrandCertificates([...updatedBrandCertificates])
        }else{
            setBrandCertificates([...brandCertificates, {...brandCertificate}])
        }

        setBrandCertificate({})
        setVisibleAddBrandCertificate(false)
    }

    const handleAddBrandCertificate = () => {
        setBrandCertificate({
            brandCertificateId: uuidv4(),
            companyId: id,
            entityType: "Brand",
            entityId: null,
            docProof: null,
            issuedDate: null,
            expiryDate: null,
            remarks: null,
            isNew: true
        })
        setVisibleAddBrandCertificate(true)
    }

    const handleCloseBrandCertificate = () => {
        setBrandCertificate({})
        setVisibleAddBrandCertificate(false)
    }

    const brandCertificateUploadHandler = async ({ files, options }, doc_name) => {
        const { fileArr, error, errorMsg } = await getUploadedFileObj({ files, options, documentName: doc_name })
        if (error) {
            return dispatch(raiseToast({ severity: 'error', detail: errorMsg, life: 3000 }))
        }
        const fileObj = fileArr[0]

        let data = {
            doc_name: "BRAND_CERTIFICATE",
            file_name: fileObj.name,
            data_uri: fileObj.dataURI,
            objectURL: fileObj.inputName
        }
        setIsLoading(true)
        let response = await uploadFile(data)

        setIsLoading(false)
        if (response) {
            brandCertificate[fileObj.inputName] = response.data
            setBrandCertificate({ ...brandCertificate })
        }
    }
    
    const addTagOptions = getAddTagsOptions(tagsConfig, tagOptions, addTagOption)
    

    let is_buyer = false
    let is_seller = false
    let is_buyer_seller = false
    const buyer_seller = initialData?.companyTypesData?.find(obj => obj.companyTypeId === editedCompanyDetails?.buyerSeller)
    
    if (buyer_seller) {
        if (buyer_seller.companyType == "Buyer") {
            is_buyer = true
        }
        else if (buyer_seller.companyType == "Seller") {
            is_seller = true
        }
        else if (buyer_seller.companyType == "Both") {
            is_buyer_seller = true
        }
    }

    let total_payment = 0
    const payment_terms = editedCompanyDetails.paymentTerms
    if (payment_terms) {
        let payment_terms_string = JSON.stringify(payment_terms);
        const payment_terms_obj = JSON.parse(payment_terms_string);
        if (payment_terms_obj) {
            delete payment_terms_obj.creditPeriodId
            const payment_values = Object.values(payment_terms_obj)
            payment_values.map((obj) => {
                const values = parseFloat(obj)
                if (values) {
                    total_payment += values
                }
            })
        }
    }
    
    let seller_credit_period_terms = initialData.companyCreditPeriodsData
    if (pmCompanyConfig.isMSMEDApplicable && (editedCompanyDetails.isMSMEDRegd === true || editedCompanyDetails.isMSMEDRegd === false)) {
        seller_credit_period_terms = seller_credit_period_terms?.filter(obj => obj.creditPeriod <= 45)
    } else {
        seller_credit_period_terms = initialData.companyCreditPeriodsData
    }

    let relatedCompanyTypes = initialData?.companyTypesData

    if(editedCompanyDetails.buyerSeller != 3){
        relatedCompanyTypes = initialData?.companyTypesData?.filter(eachType => eachType.companyType != 3)
    }
    
    let activeCompanyGSTINs = editedCompanyGSTIN?.filter(gstin => gstin.gstinCode !== editedCompanyDetails.gstinCode) // change
    let activeCompanyUserRoles = editedCompanyRoles?.filter(role => role.statusId === 1)
    let activeCompanyUsers = editedCompanyUsers?.filter(user => user.statusId === 1)

    let user_role_list = []
    let hodUserId = ''
    activeCompanyUserRoles?.map(role => {
        if (role.companyRoleName) {
            user_role_list.push(role)
        }
        if(role.companyRoleId === editedCompanyDetails?.hodUser?.userRoles?.companyRoleId){
            hodUserId = editedCompanyDetails?.hodUser?.userId
        }
    })
    
    let user_roles_without_hod = user_role_list.filter(role => role?.companyRoleId != editedCompanyDetails?.hodUser?.userRoles?.companyRoleId && role?.companyRoleName !== "BRANCH HEAD")
    let relatedCountryStates = stateList.filter(eachState => eachState.countryId === editedCompanyDetails.countryId)
    let isPANandGSTINsExists = false
    if(editedCompanyGSTIN?.length > 0){
        if(editedCompanyGSTIN?.length === 1 && (editedCompanyGSTIN[0]?.gstinCode === "URD" || editedCompanyGSTIN[0]?.gstinCode === "URP")){
            isPANandGSTINsExists = false
        }else{
            isPANandGSTINsExists = true
        }
    }

    let relatedTDSSections = tdsSections.filter(eachTDS => editedCompanyDetails.enableServicePurchase ? ![1].includes(eachTDS.tdsSectionId) : eachTDS.tdsSectionId === 1)

    let tdsApprovalRemarksVisible = false
    let paymentTermsApprovalRemarksVisible = false
    let preferredPaymentModeRemarksApprovalVisible = false
    let showRejectedPaymentTermsApprovalStatus = false
    let companyOnboardingApprovalRemarksVisible = false
    if([2, 3].includes(editedCompanyDetails.buyerSeller)){

        if((editedCompanyDetails.tdsSectionId !== companyDetails.tdsSectionId) && editedCompanyDetails.enableServicePurchase && editedCompanyDetails.tdsSectionId !== 1){
            tdsApprovalRemarksVisible = true
        }

        /*if (editedCompanyDetails.paymentTerms?.payCredit === 100) {
            if ((editedCompanyDetails.paymentTerms?.payCredit !== companyDetails.paymentTerms?.payCredit) || (editedCompanyDetails.paymentTerms?.creditPeriodId !== companyDetails.paymentTerms?.creditPeriodId)) {
                let relatedCreditPeriod = initialData.companyCreditPeriodsData?.find(eachCreditPeriodTerm => eachCreditPeriodTerm?.creditPeriodId === editedCompanyDetails.paymentTerms?.creditPeriodId)
                if (relatedCreditPeriod?.creditPeriod < 30) {
                    //paymentTermsApprovalRemarksVisible = true
                }
            }
        }*/

        //paymentTermsApprovalRemarksVisible = handlePaymentTermsApproval(editedCompanyDetails.paymentTerms, companyDetails.paymentTerms)

        if(editedCompanyDetails.preferredPaymentMode !== companyDetails.preferredPaymentMode){
            preferredPaymentModeRemarksApprovalVisible = true
        }

        if(paymentTermsApprovalInstanceData){
            if(paymentTermsApprovalInstanceData.statusId === 8 && paymentTermsApprovalInstanceData.processedTS){
                showRejectedPaymentTermsApprovalStatus = Date.parse(editedCompanyDetails.updatedAt) > Date.parse(paymentTermsApprovalInstanceData.processedTS)
            }
        }

        if(companyDetails.partialOnboarding && !editedCompanyDetails.partialOnboarding){
            companyOnboardingApprovalRemarksVisible = true
        }
    }

    let relatedCompanyOwnershipTypes = initialData.companyOwnershipTypesData
    if (!pmCompanyConfig.isInternational){
        if(editedCompanyDetails.panCode && editedCompanyDetails.gstinCode){
            if(editedCompanyDetails.panCode[3] === "F"){
                relatedCompanyOwnershipTypes = initialData.companyOwnershipTypesData?.filter(eachOwnerShipType => [3,4].includes(eachOwnerShipType.ownershipTypeId))
            }else if(editedCompanyDetails.panCode[3] === "C"){
                relatedCompanyOwnershipTypes = initialData.companyOwnershipTypesData?.filter(eachOwnerShipType => [6,7].includes(eachOwnerShipType.ownershipTypeId))
            }else{

            }
        }else{
            relatedCompanyOwnershipTypes = initialData.companyOwnershipTypesData?.filter(eachOwnerShipType => [1].includes(eachOwnerShipType.ownershipTypeId))
        }
    }

    const renderCompanyMobileSkeleton = () => <CompanyMobileSkeleton />
    const renderCompanySkeleton = () => <CompanySkeleton />

    if(skeletonLoading){
        return(
            isMobile() ? renderCompanyMobileSkeleton() : renderCompanySkeleton()
        )
    }

    let editDisabledTooltipTxt = null
    if (companyDetails.statusId === 2){
        editDisabledTooltipTxt = "Editing is disabled because the company is inactive."
    }

    const permissionDetails = checkPermissions({...userDetails, permissions: [207]})
    const isCompanyNameDisabled = !permissionDetails.isPermitted

    const tagsPermissionDetails = checkPermissions({ ...userDetails, permissions: [225] })
    const isCompanyTagDisabled = !tagsPermissionDetails.isPermitted
    const companyCreatedByUser = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === editedCompanyDetails.createdBy)

    const activeBrandCertifictes = brandCertificates.filter(eachBrandCertificate => eachBrandCertificate.statusId !== 2)

    return (
        <>
            <div className="container company-edit-container relative pb-1">
                <Toast ref={toast1}></Toast>
                <div className="company-step-header" style={{ top: 50 }}>
                    <Steps model={items} activeIndex={0} readOnly={false} />
                </div>
                <div className="p-card" style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px"}}>
                    <Toast ref={Toast} />
                    <div className="mb-3 flex flex-column md:flex-row md:justify-content-between">
                        <h4 className="mt-2 ml-2">{editedCompanyDetails.companyName} 
                            <span className="ml-1 text-gray-400">
                                (Onboarded By: {companyCreatedByUser ? getFullName(companyCreatedByUser.firstName, companyCreatedByUser.lastName) + ' on ' + getDateTimeString(editedCompanyDetails.createdAt) : 'N/A'})
                            </span>
                        </h4>
                        <div className="flex justify-content-end mt-2 md:mt-0">
                            {
                                isEditing ?
                                    <div>
                                        <Button className="small-btn discard-btn" style={{ marginRight: "10px" }} label="DISCARD" onClick={handleDiscardCompanyDetails} />
                                        <Button className="small-btn" label="SAVE" onClick={updateCompany} />
                                    </div>
                                    :
                                    <div>
                                        <Button className="small-btn" style={{ marginRight: '10px' }} label="EDIT" onClick={() => setIsEditing(true)} permissions={[26]} disabled={companyDetails.statusId === 2} tooltip={editDisabledTooltipTxt} tooltipOptions={{position: "right", showOnDisabled: true}} />
                                    </div>
                            }
                        </div>
                    </div>
                    <div className="grid mb-2">
                        <div className="flex flex-row col-12 md:col-6 align-items-center justify-content-start gap-2">
                            <div className="flex align-items-center">
                                <label className="text-sm mr-2 ml-3 text-600 font-semibold"> Partial Onboarding </label>
                                <InputSwitchField name="partialOnboarding" checked={editedCompanyDetails.partialOnboarding} onChange={(event) => handleToggleSwitchButtonChange(event)} disabled={!isEditing || !companyDetails.partialOnboarding} />
                            </div>
                            {
                                (companyOnboardingApprovalInstanceData?.regionalHead || companyOnboardingApprovalInstanceData?.dataOps) &&
                                renderOnboardingApprovalDetailsDisplay(
                                    companyOnboardingApprovalInstanceData.regionalHead,
                                    companyOnboardingApprovalInstanceData.dataOps
                                )
                            }
                        </div>
                    </div>
                    <div className="grid mx-2">
                        <div className="flex flex-column col-12 md:col-4">
                            <label htmlFor="companyName" style={{fontSize:"12px", marginBottom:"3px"}}>
                                Company Name<span style={{ color: "red" }} className="from-required">*</span>
                                <Tooltip target=".custom-target-icon" position="right" content="Please enter short company name" />
                                <i className="pi pi-info-circle custom-target-icon ml-2"></i>
                            </label>
                            <TextInputField name="companyName" id="companyName"  value={editedCompanyDetails.companyName} maxLength={100} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.companyName} required disabled={!isEditing || isCompanyNameDisabled} />
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="webpage" labelText="Company Website" value={editedCompanyDetails.webpage} maxLength={255} onChange={(event) => handleTextInputChange(event)} disabled={!isEditing} />
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="companyDescription" labelText="Company Description" value={editedCompanyDetails.companyDescription} maxLength={300} onChange={(event) => handleTextInputChange(event)} disabled={!isEditing} />
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="companyShortName" labelText="Company Legal Name" value={editedCompanyDetails.companyShortName} maxLength={100} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.companyShortName} disabled />
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <DropDownField name="buyerSeller" labelText="Buyer/Seller" placeholder={"Please Select"} options={initialData.companyTypesData} optionLabel="companyType" optionValue="companyTypeId" value={editedCompanyDetails.buyerSeller} onChange={handleTextInputChange} errorMessage={formErrors.buyerSeller} required disabled={ !isEditing || companyDetails.buyerSeller === 3 ? true : false} />
                        </div>
                        {
                            is_buyer || is_buyer_seller ?
                                <>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <label htmlFor="groupId" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                            Company Group <span style={{ color: "red" }} className="from-required">*</span>
                                            <Tooltip target=".company-group-eye-icon" position="right" content="To add a group, please contact tech team offline" />
                                            <i className="pi pi-info-circle company-group-eye-icon ml-2"></i>
                                        </label>
                                        <AutoCompleteField name="groupId" id="groupId" suggestions={relatedCompanyGroupTypes.length === 0 ? initialData?.companyGroupsData : relatedCompanyGroupTypes} field="groupName" value={editedCompanyDetails.groupId} onChange={handleTextInputChange} searchMethod={searchCompanyGroupTypes} dropdown forceSelection disabled={!isEditing} errorMessage={formErrors.groupId} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <AutoCompleteField name="clientSuccessManagerId" labelText="Client Success Manager" field="fullName" placeholder="Select User" value={editedCompanyDetails.clientSuccessManagerId} suggestions={searchedClientSuccessManagers} searchMethod={searchClientSuccessManagers} onChange={handleTextInputChange} dropdown forceSelection errorMessage={formErrors.clientSuccessManagerId} required disabled={!isEditing} />
                                    </div>
                                </> : ""
                        }
                    </div>
                    <h5 className="text-600 ml-3 mb-2 mt-2">Company Address</h5>
                    <div className="grid mx-2">
                        <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="address" labelText="Address" value={editedCompanyDetails?.address} maxLength={300} onChange={(e) => handleCompanyAddressChange(e)} errorMessage={formErrors.address} required disabled={!isEditing} />
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="city" labelText="City" value={editedCompanyDetails.city} maxLength={40} onChange={(e) => handleCompanyAddressChange(e)} errorMessage={formErrors.city} required disabled={!isEditing} />
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="pinCode" labelText="PinCode" value={editedCompanyDetails.pinCode} keyfilter={"pint"} maxLength={10} onChange={(e) => handleCompanyAddressChange(e)} errorMessage={formErrors.pinCode} autoComplete={"off"} required disabled={!isEditing} />
                        </div>
                        {
                            pmCompanyConfig.isInternational ?
                            null 
                            :
                            <>
                                <div className="flex flex-column col-12 md:col-4">
                                    <DropDownField name="stateId" labelText="State" options={relatedCountryStates} optionLabel="stateName" optionValue="stateId" value={parseInt(editedCompanyDetails?.stateId)} onChange={(e) => handleCompanyAddressChange(e)} errorMessage={formErrors.stateId} required disabled />
                                </div>
                                <div className="flex flex-column col-12 md:col-4">
                                    <DropDownField name="countryId" labelText="Country" options={initialData.countryData} optionLabel="countryName" optionValue="countryId" value={editedCompanyDetails?.countryId} onChange={(e) => handleCompanyAddressChange(e)} errorMessage={formErrors.countryId} required disabled />
                                </div>
                            </>
                        }
                    </div>
                </div>
                {
                    is_seller || is_buyer_seller ?
                        <div className="p-card">
                            <div className="flex">
                                <h5 className="ml-2 mb-2 mt-0">Brand Certificates</h5>
                            </div>
                            {
                                activeBrandCertifictes.length ?
                                    <div className="mt-2" style={{ order: "1" }}>
                                        <div className="brand-certificate-table" style={{ backgroundColor: "#edf2f0" }}>
                                            <Table
                                                lazy
                                                tableColumns={brandCertificatesTableColumns}
                                                data={activeBrandCertifictes}
                                                scrollable={"true"}
                                                scrollHeight="550px"
                                                style={{ backgroundColor: "#edf2f0", order: "1" }}
                                            />
                                        </div>
                                    </div>
                                    : null
                            }
                            <div className="increment-btn ml-2">
                                <Button className="mt-2" label="Add" outlined onClick={() => handleAddBrandCertificate()} disabled={!isEditing} />
                            </div>
                        </div>
                        : null
                }
                <div className="p-card">
                    <h5 className="ml-2 mb-3">Other Details</h5>
                    <div className="grid mx-2">
                        <div className="flex flex-row col-12 md:col-4 md:py-0 px-0 py-2">
                            <div className="flex flex-column col-9 md:col-8 lg:col-9 md:py-0 pb-2">
                                <TextInputField name="panCode" labelText="PAN" value={editedCompanyDetails.panCode} maxLength={20} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.panCode} disabled={pmCompanyConfig.isInternational ? true : (!isEditing || companyDetails.panCode)} required={ editedCompanyDetails.partialOnboarding ? false : true} permissions={[109]}/> {/* disabled={!isEditing || companyDetails.panCode} */}
                            </div>
                            <div className="flex flex-column col-3 md:mt-2 mt-3 verify-btn pb-0 pl-0">
                            {   
                                isPANandGSTINsExists ?
                                    <div className="flex justity-content-center align-items-center">
                                        <span className="refresh-btn">
                                            <Button className="refresh-btn-icon" icon="pi pi-refresh" text onClick={()=> handleVerifyClick()} size="large" disabled={editedCompanyDetails?.panCode?.length !== 10 || !isEditing || isGSTINDataLoading} permissions={[109]} />
                                        </span>
                                        <label className="text-xs mt-1" style={{ color: "green" }}>Verified!</label>
                                    </div>
                                    :
                                    <Button className="small-btn" onClick={()=> handleVerifyClick()} disabled={editedCompanyDetails?.panCode?.length !== 10 || !isEditing || isGSTINDataLoading} permissions={[109]}>Verify</Button>
                            }
                            </div>
                        </div>
                        {
                            pmCompanyConfig.isInternational ?
                                <div className="flex flex-column col-12 mb-2 md:mb-0 md:col-8 py-0">
                                    <TextInputField name="gstinCode" labelText={`Primary ${pmCompanyConfig.GSTINLabel}`} value={editedCompanyDetails.gstinCode} maxLength={20} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.gstinCode} disabled={!isEditing} permissions={[109]} {...(isGSTINDataLoading ? { loading: true, disabled: true } : {})} />
                                </div>
                                :
                                (editedCompanyGSTIN?.length > 1 ||
                                    (editedCompanyGSTIN?.length === 1 && !["URD", "URP"].includes(editedCompanyGSTIN[0].gstinCode)))
                                    ? (
                                        <div className="flex align-items-center">
                                            <Button
                                                style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}
                                                onClick={() => setVisibleViewGSTINs(true)}
                                            >
                                                View GSTINs
                                            </Button>
                                        </div>
                                    ) : (
                                        <div className="flex flex-column col-12 mb-2 md:mb-0 md:col-8 py-0">
                                            <TextInputField
                                                name="gstinCode"
                                                labelText={`Primary ${pmCompanyConfig.GSTINLabel}`}
                                                value={editedCompanyDetails.gstinCode}
                                                maxLength={35}
                                                onChange={(event) => handleTextInputChange(event)}
                                                errorMessage={formErrors.gstinCode}
                                                disabled={!isEditing}
                                                permissions={[109]}
                                                {...(isGSTINDataLoading ? { loading: true, disabled: true } : {})}
                                            />
                                        </div>
                                    )
                        }
                    </div>
                    {
                        is_buyer ? 
                            <>
                                <div className="grid my-0 mx-2 md:m-2">
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="supplyTypeId" labelText="Supply Type" options={initialData.companySupplyTypesData} optionLabel="supplyType" optionValue="supplyTypeId" value={editedCompanyDetails?.supplyTypeId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.supplyTypeId} required={!editedCompanyDetails?.partialOnboarding} disabled={pmCompanyConfig.isInternational ? true : (!isEditing || (companyDetails?.supplyTypeId && companyDetails?.supplyTypeId != 8))}/> {/** disabled={!isEditing || (companyDetails?.supplyTypeId && companyDetails?.supplyTypeId != 8)} */}
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 md:col-4">
                                        <DropDownField name="prefPMStateId" labelText="Pref PM State" options={prefPMStateList} optionLabel="stateName" optionValue="stateId" value={editedCompanyDetails.prefPMStateId} onChange={(event) => handleTextInputChange(event)} disabled={!isEditing} />
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 md:col-4">
                                        <DropDownField name="prefPMBranchId" labelText="Pref PM Branch" options={prefPMBranches} optionLabel="branchName" optionValue="branchId" value={editedCompanyDetails.prefPMBranchId} onChange={(event) => handleTextInputChange(event)} optionDisabled="optionDisabled" errorMessage={formErrors.prefPMBranchId} disabled={!isEditing} required />
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 md:col-4">
                                        <DropDownField name="prefPMBankId" labelText="Pref PM Bank Details" options={pmCompanyDetails?.companyBankAccounts} optionLabel="bankName" optionValue="bankAccId" value={editedCompanyDetails?.prefPMBankId} onChange={(event) => handleTextInputChange(event)} disabled={!isEditing} />
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <div className="grid my-0 mx-2 md:m-2">
                                    {
                                        is_buyer_seller || editedCompanyDetails.buyerSeller === null ?
                                            <div className="flex flex-column col-12 md:col-4">
                                                <DropDownField name="supplyTypeId" labelText="Supply Type" options={initialData.companySupplyTypesData} optionLabel="supplyType" optionValue="supplyTypeId" value={editedCompanyDetails?.supplyTypeId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.supplyTypeId} required={!editedCompanyDetails?.partialOnboarding} disabled={pmCompanyConfig.isInternational ? true : (!isEditing || (companyDetails?.supplyTypeId && companyDetails?.supplyTypeId != 8))} /> {/** disabled={!isEditing || (companyDetails?.supplyTypeId && companyDetails?.supplyTypeId != 8)} */}
                                            </div> : ""
                                    }
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="ownershipTypeId" labelText="Ownership Type" options={relatedCompanyOwnershipTypes} optionLabel="ownershipType" optionValue="ownershipTypeId" value={editedCompanyDetails?.ownershipTypeId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.ownershipTypeId} required={!editedCompanyDetails?.partialOnboarding} disabled={!isEditing} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="sizeId" labelText="Size" options={initialData.companySizeCategoriesData} optionLabel="sizeCategory" optionValue="sizeCategoryId" value={editedCompanyDetails?.sizeId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.sizeId} required={!editedCompanyDetails?.partialOnboarding} disabled={!isEditing} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="businessTypeId" labelText="Business Type" options={initialData.companyBusinessTypesData} optionLabel="businessType" optionValue="businessTypeId" value={editedCompanyDetails?.businessTypeId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.businessTypeId} required={!editedCompanyDetails?.partialOnboarding} disabled={!isEditing} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="turnoverCategoryId" labelText="Annual Turnover (In Cr)" options={initialData.companyTurnoverCategoriesData} optionLabel="turnoverCategory" optionValue="turnoverCategoryId" value={editedCompanyDetails?.turnoverCategoryId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.turnoverCategoryId} required={!editedCompanyDetails?.partialOnboarding} disabled={!isEditing} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="prefPMBankId" labelText="Pref PM Bank Details" options={pmCompanyDetails?.companyBankAccounts} optionLabel="bankName" optionValue="bankAccId" value={editedCompanyDetails?.prefPMBankId} onChange={(event) => handleTextInputChange(event)} disabled={!isEditing} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="prefPMStateId" labelText="Pref PM State" options={prefPMStateList} optionLabel="stateName" optionValue="stateId" value={editedCompanyDetails?.prefPMStateId} onChange={(event) => handleTextInputChange(event)} disabled={!isEditing} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="prefPMBranchId" labelText="Pref PM Branch" options={prefPMBranches} optionLabel="branchName" optionValue="branchId" value={editedCompanyDetails.prefPMBranchId} onChange={(event) => handleTextInputChange(event)} optionDisabled="optionDisabled"  disabled={!isEditing} errorMessage={formErrors.prefPMBranchId} required />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <MultiSelectField name="indicativeIndustryList" labelText="Indicative Industry List" options={materialCategories} optionLabel="categoryName" optionValue="categoryId" value={editedCompanyDetails.indicativeIndustryList} onChange={(event) => handleTextInputChange(event)} disabled={!isEditing} optionDisabled={(eachCategory) => handleIndustryListOptionDisabled(eachCategory)} />
                                    </div>
                                </div>
                                {
                                    pmCompanyConfig.isInternational ? 
                                    null :
                                    <>
                                        <div className="grid my-0 mx-2 md:mb-0 md:mt-2">
                                            <div className="flex col-12 mb-1 md:col-4 align-items-center" style={{}}>
                                                <label className="text-xs mr-2"> TDS Section 194Q </label>
                                                <InputSwitchField name="tdsSection194q" checked={editedCompanyDetails.tdsSection194q} onChange={(event) => handleToggleSwitchButtonChange(event)} disabled />
                                            </div>
                                        </div>
                                        {
                                            (is_seller || is_buyer_seller) && editedCompanyDetails.buyerSeller !== null ?
                                            <div className="grid my-0 mx-2">
                                                <Tooltip target=".custom-target-icon" />
                                                <div className="flex col-12 mb-1 lg:col-4 md:col-4 lg:mb-0 align-items-center" style={{}}>
                                                    <label className="text-xs mr-2"> Enable Services Purchase <i className="pi pi-info-circle custom-target-icon" data-pr-tooltip={"Materials can be procure from any onboarded vendor. to purchase services from vendor please enable below"} data-pr-position="bottom" style={{ fontSize: '0.7rem',cursor: 'pointer' }}></i> </label>
                                                    <InputSwitchField name="enableServicePurchase" checked={editedCompanyDetails.enableServicePurchase} onChange={(event) => handleToggleSwitchButtonChange(event)} disabled={!isEditing} />
                                                </div>
                                                <div className="flex flex-column md:flex-row col-12 md:col-6 md:align-items-center gap-2">
                                                    {
                                                        editedCompanyDetails.enableServicePurchase ?
                                                            <>
                                                                <label htmlFor="tdsSectionId" className="px-0 md:align-items-center" style={{ fontSize: "12px" }}>
                                                                    TDS Section Type {is_seller && !editedCompanyDetails.enableServicePurchase ? <span style={{ color: "red" }} className="from-required">*</span> : ""}&nbsp; :
                                                                </label>
                                                                <div className="col-12 md:w-4 lg:w-5 md:align-items-center px-0">
                                                                    <DropDownField name="tdsSectionId" labelText="" options={relatedTDSSections} optionLabel={(eachTDS) => `${eachTDS.tdsSectionName} - ${eachTDS.tdsSectionDesc}`} optionValue="tdsSectionId" value={editedCompanyDetails.tdsSectionId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.tdsSectionId} required disabled={!isEditing} />
                                                                </div>
                                                            </> : ""
                                                    }
                                                    <div className="ml-4 pl-0">
                                                        {
                                                            tdsApprovalInstanceData?.statusId === 12 ? renderApprovalDetailsDisplay(tdsApprovalInstanceData) : ""
                                                        }
                                                    </div>
                                                </div>
                                            </div> : ""
                                        }
                                    </>
                                }
                                <div className="hr-line" />
                                <Tooltip target=".custom-target-icon" />
                                <h5 className="text-600 mt-3 ml-3 mb-2"> {pmCompanyConfig.MSMEDLabel} <i className="pi pi-info-circle custom-target-icon" data-pr-tooltip={"Not registered :- Please upload pdf or screenshot of the email confirmation from the vendor about MSMED act registration status. \nRegistered :- Please upload pdf or screenshot of MSMED act registration certificate"} data-pr-position="bottom" style={{ fontSize: '0.8rem',cursor: 'pointer' }}></i>{ !editedCompanyDetails.partialOnboarding ? <span style={{ color: "red" }} className="from-required">*</span> : null}</h5>
                                <div className="flex flex-column">
                                    <div className="grid flex flex-row">
                                        <div className="flex col-12 md:col-4">
                                            <div className="my-1 flex flex-row ">
                                                <RadioButton className="ml-4" inputId="not-required" name="not-required" value="Not Registered" onChange={(e) => handleMSMEDChange(e)} checked={ editedCompanyDetails.isMSMEDRegd === false } disabled={pmCompanyConfig.isInternational ? true : !isEditing}/> {/** disabled={!isEditing} */}
                                                <label htmlFor="not-required" className="ml-2 text-sm">Not Regd</label>
                                            </div>
                                            <div className="my-1 flex ml-3">
                                                <RadioButton inputId="not-required" name="not-required" value="Registered" onChange={(e) => handleMSMEDChange(e)} checked={editedCompanyDetails.isMSMEDRegd } disabled={pmCompanyConfig.isInternational ? true : !isEditing} />{/** disabled={!isEditing} */}
                                                <label htmlFor="not-required" className="ml-2 text-sm">Regd</label>
                                            </div>
                                        </div>
                                        {
                                            editedCompanyDetails.isMSMEDRegd ?
                                                <div className="flex flex-column md:flex-row col-12 md:col-4 mt-2 md:mt-0 pt-0 md:align-items-center md:gap-2 ml-2">
                                                    <label htmlFor="tdsSectionId" className="flex pt-0 md:align-items-center ml-2 md:ml-0" style={{ fontSize: "12px" }}>
                                                        {pmCompanyConfig.MSMEDLabel} Type {is_seller && editedCompanyDetails.isMSMEDRegd ? <span style={{ color: "red" }} className="from-required">*</span> : ""}&nbsp;&nbsp; :
                                                    </label>
                                                    <div className="col-12 md:col-5 lg:col-5 align-items-center">
                                                        <DropDownField name="companyMSMEDTypeId" labelText="" options={companyMSMEDTypes} optionLabel="companyMSMEDType" optionValue="companyMSMEDTypeId" value={editedCompanyDetails.companyMSMEDTypeId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.companyMSMEDTypeId} disabled={pmCompanyConfig.isInternational ? true : !isEditing} required />
                                                    </div>
                                                </div> : ""
                                        }
                                    </div>
                                    {
                                        !pmCompanyConfig.isInternational &&
                                        <div className="ml-5">
                                            {formErrors.isMSMEDRegd && <small className='p-error' style={{ fontSize: 'x-small'}}>{formErrors.isMSMEDRegd}</small>}
                                        </div>
                                    }
                                </div>
                            </>
                    }
                    {/* <div className="hr-line" />
                    <h5 className="text-600 mt-3 ml-3">Tags</h5>
                    <div>
                        {
                            tagOptions.map((eachTag, index) => {
                                return (
                                    <div className="flex align-items-center m-0 p-0" key={`companyTags-${eachTag.companyTagId}`} style={{ fontSize: "13px" }}>
                                        <div className={`flex flex-column ml-4 mr-2`}>
                                            {index + 1}.
                                        </div>
                                        <div className="flex align-items-center m-0 p-0">
                                            <label className="mr-3" style={{minWidth: "200px"}}>
                                                {eachTag.tagLabel}:
                                            </label>
                                            {
                                                eachTag.tagType?.toLowerCase() === 'integer' ?
                                                    <div className="" style={{width: "200px"}}>
                                                        <TextInputField name="tagValue" labelText="" value={eachTag.tagValue} keyfilter={"pint"} onChange={(event) => handleOnChangeTagValue(event, eachTag.companyTagId)} disabled={!isEditing || isCompanyTagDisabled} />
                                                    </div> : null
                                            }
                                            {
                                                eachTag.tagType?.toLowerCase() === 'boolean' ?
                                                    <div className="" style={{width: "200px"}}>
                                                        <InputSwitchField name="tagValue" checked={eachTag.tagValue} onChange={(event) => handleOnChangeTagValue(event, eachTag.companyTagId)} disabled={!isEditing || isCompanyTagDisabled} />
                                                    </div> : null
                                            }
                                            {
                                                eachTag.tagType?.toLowerCase() === 'string' ?
                                                    <div className="" style={{width: "200px"}}>
                                                        <TextInputField name="tagValue" labelText="" value={eachTag.tagValue} onChange={(event) => handleOnChangeTagValue(event, eachTag.companyTagId)} required maxLength={100} disabled={!isEditing || isCompanyTagDisabled} />
                                                    </div> : null
                                            }
                                            {
                                                eachTag.tagType?.toLowerCase() === 'select' ?
                                                    <div className="" style={{ width: "200px" }}>
                                                        <DropDownField name="tagValue" labelText="" options={eachTag.tagConfig?.options} optionLabel="value" optionValue="value" value={eachTag.tagValue} onChange={(event) => handleOnChangeTagValue(event, eachTag.companyTagId)} disabled={!isEditing || isCompanyTagDisabled} />
                                                    </div> : null
                                            }
                                            {
                                                eachTag.tagType?.toLowerCase() === 'multiselect' ?
                                                    <div className="" style={{width: "200px"}}>
                                                        <MultiSelectField name="tagValue" labelText="" options={eachTag.tagConfig?.options} optionLabel="value" optionValue="value" value={eachTag.tagValue} onChange={(event) => handleOnChangeTagValue(event, eachTag.companyTagId)} className="multiselect-input-width" disabled={!isEditing || isCompanyTagDisabled} />
                                                    </div> : null
                                            }
                                        </div>
                                        <div className="flex flex-column col-12 md:col-1" style={{width: "100px"}}>
                                            <span className="decrement-btn p-0">
                                                <Button className="decrement-btn-icon p-1" icon="pi pi-minus-circle" text onClick={() => handleRemoveTags(eachTag.companyTagId)} size="medium" disabled={!isEditing || isCompanyTagDisabled} />
                                            </span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className="increment-btn ml-3">
                            <div className="flex col-12">
                                <Menu model={addTagOptions} popup menuRef={addTagsMenu} id='company-tags' />
                                <Button icon="pi pi-plus-circle" className="small-btn h-2rem p-2 action-btn hover:surface-300 hover:text-700" label="New Tags" onClick={(e) => addTagsMenu.current.toggle(e)} disabled={!isEditing || isCompanyTagDisabled} />
                            </div>
                        </div>
                    </div> */}
                    <div className="hr-line" />
                    <div className="flex flex-row">
                        <h5 className="text-600 mt-3 ml-2 mb-2 md:ml-3 md:mb-0">Payment Terms {!editedCompanyDetails.partialOnboarding ? <span style={{ color: "red" }} className="from-required">*</span> : null}</h5>
                        {
                            [8, 12].includes(paymentTermsApprovalInstanceData?.statusId) && !showRejectedPaymentTermsApprovalStatus ? renderApprovalDetailsDisplay(paymentTermsApprovalInstanceData) : null
                        }
                    </div>
                    <div className="grid px-3 lg:ml-3 lg:p-2 pb-1">
                        <div className="flex flex-column col-12 md:col-2">
                            <TextInputField name="payAdvPO" labelText="Adv against PO (%)" keyfilter="pnum" value={editedCompanyDetails?.paymentTerms?.payAdvPO} onChange={(e) => handlePaymentTermsChange(e)} onBlur={handlePaymentTermsOnBlur} disabled={!isEditing} />
                        </div>
                        <div className="flex flex-column col-12 md:col-2">
                            <TextInputField name="payAdvDelivery" labelText="Adv before Delivery (%)" keyfilter={"pnum"} value={editedCompanyDetails?.paymentTerms?.payAdvDelivery} onChange={(e) => handlePaymentTermsChange(e)} onBlur={handlePaymentTermsOnBlur} disabled={!isEditing} />
                        </div>
                        <div className="flex flex-column col-12 md:col-2">
                            <TextInputField name="payPDCDelivery" labelText="PDC on Delivery (%)" keyfilter={"pnum"} value={editedCompanyDetails?.paymentTerms?.payPDCDelivery} onChange={(e) => handlePaymentTermsChange(e)} onBlur={handlePaymentTermsOnBlur} disabled={!isEditing} />
                        </div>
                        <div className="flex flex-column col-12 md:col-2">
                            <TextInputField name="payOnDelivery" labelText="Pay against Delivery (%)" keyfilter={"pnum"} value={editedCompanyDetails?.paymentTerms?.payOnDelivery} onChange={(e) => handlePaymentTermsChange(e)} onBlur={handlePaymentTermsOnBlur} disabled={!isEditing} />
                        </div>
                        <div className="flex flex-column col-12 md:col-2 lg:col-1">
                            <TextInputField name="payCredit" labelText="Credit (%)" keyfilter={"pnum"} value={editedCompanyDetails?.paymentTerms?.payCredit} onChange={(e) => handlePaymentTermsChange(e)} onBlur={handlePaymentTermsOnBlur} disabled={!isEditing} />
                        </div>
                        {
                            parseFloat(editedCompanyDetails?.paymentTerms?.payCredit) > 0 || parseFloat(editedCompanyDetails?.paymentTerms?.payPDCDelivery) > 0 ?
                                <div className="flex flex-column col-12 md:col-2">
                                    <DropDownField name="creditPeriodId" labelText="Credit Period" options={seller_credit_period_terms} optionLabel="creditPeriodName" optionValue="creditPeriodId" value={editedCompanyDetails?.paymentTerms?.creditPeriodId} onChange={(e) => handlePaymentTermsChange(e)} onBlur={handlePaymentTermsOnBlur} disabled={!isEditing} />
                                </div> : ""
                        }
                        <div className="flex flex-column col-12 md:col-1 md:mt-2">
                            <p className={`font-bold m-0 lg:mt-3 text-${total_payment == 100 ? 'green-600' : 'red-500'}`}> {total_payment} </p>
                        </div>
                    </div>

                    {(is_seller || is_buyer_seller) &&
                        <>
                            <h5 className="text-600 mt-2 ml-3">Preferred Payment Mode <span style={{ color: "red" }} className="from-required">*</span></h5>
                            <div className="m-0">
                                <div className="flex flex-column mt-3">
                                    <div className="grid flex ml-5">
                                        <div className="my-1 flex">
                                            <RadioButton inputId="CHEQUE" name="CHEQUE" value="CHEQUE" onChange={handlePreferredPaymentModeChange} checked={editedCompanyDetails.preferredPaymentMode === 'CHEQUE'} disabled={!isEditing} />
                                            <label htmlFor="CHEQUE" className="ml-2 text-xs">CHEQUE</label>
                                        </div>
                                        <div className="my-1 flex ml-3">
                                            <RadioButton inputId="BANK TRANSFER" name="BANK TRANSFER" value="BANK TRANSFER" onChange={handlePreferredPaymentModeChange} checked={editedCompanyDetails.preferredPaymentMode == 'BANK TRANSFER'} disabled={!isEditing} />
                                            <label htmlFor="BANK TRANSFER" className="ml-2 text-xs">BANK TRANSFER</label>
                                        </div>
                                        { preferredPaymentModeApprovalInstanceData?.statusId === 12 ? 
                                            renderApprovalDetailsDisplay(preferredPaymentModeApprovalInstanceData) : ""
                                        }
                                    </div>
                                    <div className="ml-5">
                                        {formErrors.preferredPaymentMode && <small className='p-error' style={{ fontSize: 'x-small' }}>{formErrors.preferredPaymentMode}</small>}
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    {
                        is_buyer ? "" :
                            <>
                                <div className="hr-line" />
                                <div>
                                    <h5 className="text-600 mt-3 mb-3 ml-3">Upload Files</h5>
                                    <div className="grid upload-file ml-3">
                                        <div className="flex align-items-center col-12 md:col-4 lg:col-2 lg:mb-0 gstin-certificate">
                                            <label htmlFor="gstCert" className="text-xs mb-1 mr-2">{pmCompanyConfig.GSTINLabel} { !editedCompanyDetails.partialOnboarding ? <span style={{ color: "red" }} className="from-required">*</span> : null}: </label>
                                            {
                                                !editedCompanyDetails.gstCert ?
                                                    <div>
                                                        <FileUpload mode="basic" name="gstCert" accept="image/pdf/*" customUpload uploadHandler={(files) => fileUploadHandler(files, "GSTIN_CERTIFICATE")} auto chooseLabel="Upload" disabled={!isEditing} />
                                                    </div>
                                                    :
                                                    <FileViewAndRemove doc={{url: editedCompanyDetails.gstCert}} showRemove disableRemove={!isEditing} handleRemoveDoc={removeCompanyRelatedCertificates} docName="gstCert" />
                                            }
                                        </div>
                                        <div className="flex align-items-center col-12 md:col-4 lg:col-2 lg:mb-0">
                                            <label htmlFor="aadharCert" className="text-xs mb-1 mr-2">Aadhar : </label>
                                            {
                                                !editedCompanyDetails.aadharCert ?
                                                    <div>
                                                        <FileUpload mode="basic" name="aadharCert" accept="image/pdf/*" customUpload uploadHandler={(files) => fileUploadHandler(files, "AADHAR_CERTIFICATE")} auto chooseLabel="Upload" disabled={pmCompanyConfig.isInternational ? true : !isEditing} /> {/** disabled={!isEditing} */}
                                                    </div>
                                                    :
                                                    <FileViewAndRemove doc={{url: editedCompanyDetails.aadharCert}} showRemove disableRemove={!isEditing} handleRemoveDoc={removeCompanyRelatedCertificates} docName="aadharCert" />
                                            }
                                        </div>
                                        <div className="flex align-items-center col-12 md:col-4 lg:col-2 lg:mb-0">
                                            <label htmlFor="panCert" className="text-xs mb-1 mr-2">PAN : </label>
                                            {
                                                !editedCompanyDetails.panCert ?
                                                    <div>
                                                        <FileUpload mode="basic" name="panCert" accept="image/pdf/*" customUpload uploadHandler={(files) => fileUploadHandler(files, "PAN_CERTIFICATE")} auto chooseLabel="Upload" disabled={pmCompanyConfig.isInternational ? true : !isEditing} /> {/** disabled={!isEditing} */}
                                                    </div>
                                                    :
                                                    <FileViewAndRemove doc={{url: editedCompanyDetails.panCert}} showRemove disableRemove={!isEditing} handleRemoveDoc={removeCompanyRelatedCertificates} docName="panCert" />
                                            }
                                        </div>
                                        <div className="flex align-items-center col-12 md:col-4 lg:col-3 lg:mb-0">
                                            <label htmlFor="msmedCert" className="text-xs mb-1 mr-2">{pmCompanyConfig.MSMEDLabel} Document { !editedCompanyDetails.partialOnboarding ? <span style={{ color: "red" }} className="from-required">*</span> : null}:</label>
                                            {
                                                !editedCompanyDetails.msmedCert ?
                                                    <div>
                                                        <FileUpload mode="basic" name="msmedCert" accept="image/pdf/*" customUpload uploadHandler={(files) => fileUploadHandler(files, "MSMED_CERTIFICATE")} auto chooseLabel="Upload" disabled={pmCompanyConfig.isInternational ? true : !isEditing} /> {/** disabled={!isEditing} */}
                                                    </div>
                                                    :
                                                    <FileViewAndRemove doc={{url: editedCompanyDetails.msmedCert}} showRemove disableRemove={!isEditing} handleRemoveDoc={removeCompanyRelatedCertificates} docName="msmedCert" />
                                            }
                                        </div>
                                        <div className="flex align-items-center col-12 md:col-4 lg:col-3 lg:mb-0">
                                            <label htmlFor="incorporationCert" className="text-xs mb-1 mr-2">Incorporation : </label>
                                            {
                                                !editedCompanyDetails.incorporationCert ?
                                                    <div>
                                                        <FileUpload mode="basic" name="incorporationCert" accept="image/pdf/*" customUpload uploadHandler={(files) => fileUploadHandler(files, "INCORPORATION_CERTIFICATE")} auto chooseLabel="Upload" disabled={pmCompanyConfig.isInternational ? true : !isEditing} />{/** disabled={!isEditing} */}
                                                    </div>
                                                    :
                                                    <FileViewAndRemove doc={{url: editedCompanyDetails.incorporationCert}} showRemove disableRemove={!isEditing} handleRemoveDoc={removeCompanyRelatedCertificates} docName="incorporationCert" />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                    }
                </div>
                {
                    pmCompanyConfig.isInternational ? 
                    <div className="p-card">
                        <h5 className="text-600 mt-3 mb-2">Billing Address <span style={{ color: "red" }} className="from-required">*</span></h5>
                        <div className="">
                            <div className="increment-btn ml-2">
                                <Button className="increment-btn-icon" icon="pi pi-plus-circle" text size="large" onClick={() => setVisibleAddNewBillingAddr(true)} disabled={!isEditing}/>
                            </div>
                            <Dialog header="Add New Billing Address" className='add-new-shipping-address' visible={visibleAddNewBillingAddr} style={{ width: '50vw', minHeight: "35%" }} onHide={() => setVisibleAddNewBillingAddr(false)} >
                                <AddBillingAddress stateList={statesDetails} countriesData={countriesData} handleSubmit={handleSubmitBllAddr} pinCodesData={pinCodesData} />
                            </Dialog>
                        </div>
                            <div className='' style={{ width: "auto" }}>
                            <div className="grid mt-1 flex flex-column shipping-address-container align-items-stretch max-h-27rem">
                                {
                                    editedCompanyBillAddrs.length > 0 && 
                                    editedCompanyBillAddrs?.map((addr) => {
                                        let relatedState = statesDetails.find(state => state.stateId === parseInt(addr.stateId))
                                        let location = addr.loc ? addr.loc : addr.city
                                        return (
                                            <div key={`companyBillAddrs-${addr.billAddrId}`} className="flex flex-column col-12 md:col-5 border-solid border-1 shipping-add-card border-300 border-around-1 m-2 border-round justify-content-between text-xs" style={{ backgroundColor: '#fafafaa3' }}>
                                                <div className='flex p-1 flex-column'>
                                                    <div className=''><span className='text-900 font-medium'>Address: </span> {addr.billAddress} </div>
                                                    <div className=''><span className='text-900 font-medium'>{pmCompanyConfig.GSTINLabel}: </span> {addr.gstinCode} </div>
                                                    <div className=''><span className='text-900 font-medium'>City: </span>{location} </div>
                                                    <div className=''><span className='text-900 font-medium'>State: </span> {relatedState?.stateName} </div>
                                                    <div className=''><span className='text-900 font-medium'>Pin: </span> {addr.pinCode} </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    :
                    null
                }
                <div className="p-card">
                    <h5>Add Company Roles</h5>
                    <div className="grid">
                        <div className="mx-2 flex flex-column col-12 md:col-4 lg:col-3 pb-0">
                            <div>
                                {
                                    activeCompanyUserRoles?.map((roleObj, index) => {
                                        return (
                                            <div className="m-2 flex flex-row" key={index}>
                                                <span className="mx-2 mt-2">
                                                    {index + 1}
                                                </span>
                                                <TextInputField value={roleObj.companyRoleName} onChange={(event) => handleCompanyRoleChange(event, roleObj.companyRoleId)} onBlur={(event) => handleCompanyRoleInputBlur(event, roleObj.companyRoleId)} errorMessage={formCompanyRolesErrors[`[${index}].companyRoleName`]} disabled={(roleObj.companyRoleId && !roleObj.isNew) || !isEditing} />
                                                {
                                                    editedCompanyDetails.hodRole !== roleObj.companyRoleName ?
                                                        <span className="ml-2 decrement-btn">
                                                            <Button className="decrement-btn-icon" icon="pi pi-minus-circle" text onClick={() => deleteCompanyRole(roleObj.companyRoleId, roleObj.isNew)} size="large" disabled={!isEditing || !roleObj.isNew} />
                                                        </span> : ""
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className="increment-btn">
                                <Button className="increment-btn-icon" icon="pi pi-plus-circle" text onClick={addCompanyRole} size="large" disabled={!isEditing} />
                            </div>
                        </div>
                    </div>
                    <div className="hr-line"/>
                    <div className="mt-3 mb-2 flex flex-column lg:flex-row justify-content-between">
                        <h5 className="text-600">Users with Company-Wide Access <i className="pi pi-info-circle custom-target-icon" data-pr-tooltip={"Users with access to All Branches"} data-pr-position="bottom" style={{ fontSize: '0.8rem',cursor: 'pointer' }}></i></h5>
                        <div className="flex flex-column col-12 md:col-3  lg:col-3 lg:mb-0">
                            <AutoCompleteField name="hodUser" labelText="Add User" value={userName} placeholder="Search user" field="fullName" searchMethod={companyUsersSearchMethod} suggestions={companyUsersSuggestions} onChange={(e) => handleAddUserCompanyRole(e)} dropdown forceSelection disabled={!isEditing || companyDetails.buyerSeller != 1} />
                        </div>
                    </div>
                    <div className="ml-2">
                        {
                            activeCompanyUsers?.map((eachUser, index) => {
                                return (
                                    <div className="grid" key={`companyUser-${eachUser.userId}`} style={{ marginBottom: "-1.5rem"}}>
                                        <div className="flex col-12 md:col-3 p-0 m-0">
                                            <div className={`flex flex-column ml-4 mt-${index === 0 ? '5' : '3'} lg:mb-2`}>
                                                {index + 1}
                                            </div>
                                            <div className="flex flex-column col-12 md:col-10">
                                                <TextInputField name="userName" labelText={index === 0 ? "User Name" : ""} value={`${getFullName(eachUser.firstName, eachUser.lastName)}`} onChange={(e) => handleCompanyUserChange(e, eachUser.userId)} errorMessage={formCompanyUsersErrors[`[${index}].firstName`]} disabled required maxLength={100} />
                                            </div>
                                        </div>
                                        <div className="flex col-12 md:col-7 p-0 m-0">
                                            <div className="flex flex-column col-12 mb-2 md:col-3">
                                                <TextInputField name="phoneNumber" labelText={index === 0 ? "Phone" : ""} value={eachUser.phoneNumber} keyfilter={"pint"} onChange={(e) => handleCompanyUserChange(e, eachUser.userId)} errorMessage={formCompanyUsersErrors[`[${index}].phoneNumber`]} disabled required maxLength={10} />
                                            </div>
                                            <div className="flex flex-column col-12 mb-2 md:col-6">
                                                <TextInputField name="emailId" labelText={index === 0 ? "Email" : ""} value={eachUser.emailId} onChange={(e) => handleCompanyUserChange(e, eachUser.userId)} errorMessage={formCompanyUsersErrors[`[${index}].emailId`]} disabled required maxLength={100} />
                                            </div>
                                            <div className="flex flex-column col-12 mb-2 md:col-3">
                                                <DropDownField name="companyRoleId" labelText={index === 0 ? "Role" : ""} options={eachUser.userId === hodUserId ? user_role_list : user_roles_without_hod} value={eachUser?.userRoles?.companyRoleId} optionLabel="companyRoleName" optionValue="companyRoleId" onChange={(e) => handleCompanyUserChange(e, eachUser.userId)} errorMessage={formCompanyUsersErrors[`[${index}].userRoles.companyRoleId`]} disabled={eachUser.userId === hodUserId ? true : !isEditing} required />
                                            </div>
                                        </div>
                                        <div className="flex col-12 md:col-2 p-0 m-0">
                                            <div className="flex flex-column col-12 md:col-8">
                                                {index === 0 && <label style={{ fontSize:"13px" }}>Whatsapp/GChat</label>}
                                                <div className="flex col-12 md:col-8">
                                                    <div className="col-6 md:col-8" style={{ cursor: 'pointer' }} onClick={() => window.open(`https://wa.me/${eachUser.phoneNumber}`)}>{eachUser.phoneNumber && <i className="pi pi-whatsapp pl-1 doc-copy-icon" style={{ color: "#00baaa" }}></i>}</div>
                                                    <a style={{ cursor: "pointer" }} className="col-6 md:col-8" onClick={() => handleGetGoogleUserChatUri(eachUser.emailId)}>
                                                        <img
                                                            className="ml-1 mb-0 mt-0"
                                                            src={googleChatIcon}
                                                            style={{ height: 13, fontSize:"13px" }}
                                                            alt="Google Chat"
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className={`flex flex-column col-12 ${index === 0 ? 'mt-3' : ''} md:col-4 lg:col-4`}>
                                                <span className="decrement-btn">
                                                    <Button className="decrement-btn-icon" icon="pi pi-minus-circle" text onClick={() => handleCompanyUserDecrement(eachUser.userId, eachUser.isNew, eachUser)} size="large" disabled={!isEditing} />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <Dialog header="Brand Certificate" className='mb-3' visible={visibleAddBrandCertificate} onHide={() => handleCloseBrandCertificate()}>
                    <div>
                        <div className="grid" key={`companyUser-${1}`}>
                            <div className="flex flex-column col-12 mb-2 lg:col-5 lg:mb-0">
                                <AutoCompleteField name="entityId" labelText="Brand" field="brandName" placeholder="Search brand" value={brandCertificate.entityId} suggestions={searchedMaterialBrands} searchMethod={searchBrands} onChange={(e) => handleBrandCertificateInputChange(e)} dropdown forceSelection required />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                <CalendarField name="issuedDate" labelText="Issued Date" placeholder="" value={brandCertificate.issuedDate && new Date(brandCertificate.issuedDate)} onChange={(e) => handleBrandCertificateInputChange(e)} required />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                <CalendarField name="expiryDate" labelText="Expiry Date" placeholder="" value={brandCertificate.expiryDate && new Date(brandCertificate.expiryDate)} onChange={(e) => handleBrandCertificateInputChange(e)} required />
                            </div>
                            <div className="align-items-center col-12 mb-2 md:col-4 lg:col-3 lg:mb-0 gstin-certificate">
                                <label htmlFor="brandCert" className="text-xs mb-1 mr-2">
                                    Brand Certificate
                                    {brandCertificate.entityId && brandCertificate.entityId.config?.certificateProofMandatory ? <span style={{ color: "red" }} className="from-required">*</span> : null}
                                </label>
                                {
                                    !brandCertificate.docProof ?
                                        <div>
                                            <FileUpload mode="basic" name="docProof" accept="image/pdf/*" customUpload uploadHandler={(files) => brandCertificateUploadHandler(files, "BRAND_CERTIFICATE")} auto chooseLabel="Upload" />
                                        </div>
                                        :
                                        <FileViewAndRemove doc={{ url: brandCertificate.docProof }} showRemove handleRemoveDoc={() => handleRemoveBrandCertificateDoc(brandCertificate)} />
                                }
                            </div>
                        </div>
                        <TextAreaField name="remarks" className="mb-3" labelText="Enter remarks" value={brandCertificate.remarks} rows={3} onChange={e => handleBrandCertificateInputChange(e)} />
                    </div>
                    <div className="flex justify-content-end mt-2 md:mt-0">
                        <Button label="Submit" className="small-btn" onClick={() => handleSubmitBrandCertificate()} autoFocus applyThrottle={true} />
                    </div>
                </Dialog>
                <Dialog header={"Approval Remarks"} className='mb-3 approval-remark-dialog' visible={visibleApprovalRemarks} onHide={() => setVisibleApprovalRemarks(false)}>
                    {
                        tdsApprovalRemarksVisible ? 
                            <TextAreaField maxLength={400} name="tdsApprovalRemarks" className="mb-3" labelText="Enter remarks for TDS section approval" value={tdsApprovalRemarks} rows={3} onChange={e => setTDSApprovalRemarks(e.target.value)} />
                            : ""
                    }
                    {
                        paymentTermsApprovalRemarksVisible ?
                            <TextAreaField maxLength={400} name="paymentTermsApprovalRemarks" labelText="Enter remarks for payment terms approval" value={paymentTermsApprovalRemarks} rows={3} onChange={e => setPaymentTermsApprovalRemarks(e.target.value)} />
                            : ""
                    }
                    {
                        companyOnboardingApprovalRemarksVisible ?
                            <TextAreaField maxLength={400} name="companyOnboardingApprovalRemarks" labelText="Enter remarks for company onboarding approval" value={companyOnboardingApprovalRemarks} rows={3} onChange={e => setCompanyOnboardingApprovalRemarks(e.target.value)} />
                            : ""
                    }
                    {
                        preferredPaymentModeRemarksApprovalVisible ? 
                            <TextAreaField maxLength={400} name="preferredPaymentModeRemarks" className="mb-3" labelText="Enter remarks for preferred payment mode approval" value={preferredPaymentModeRemarks} rows={3} onChange={e => setpreferredPaymentModeRemarks(e.target.value)} />
                            : ""
                    }
                    <div className='flex flex-row justify-content-end'>
                        <Button className="mt-2" label="SUBMIT" outlined onClick={() => handleSubmitEditCompanyWithApproval()} />
                    </div>
                </Dialog>
                <SACCode 
                    visibleSACCode={visibleSACCode}
                    setVisibleSACCode={setVisibleSACCode}
                    SACCodesData={SACCodesData}
                    selectedSACCode={selectedSACCode}
                    setSelectedSACCode={setSelectedSACCode}
                />
                <ViewGSTINs
                    visibleViewGSTINs={visibleViewGSTINs}
                    setVisibleViewGSTINs={setVisibleViewGSTINs}
                    companyGSTIN={companyGSTIN}
                    setEditedCompanyGSTIN={setEditedCompanyGSTIN}
                    gstinData={editedCompanyGSTIN}
                    billingAddress={editedCompanyBillAddrs}
                    companyDetails={companyDetails}
                    editedCompanyDetails={editedCompanyDetails}
                    setEditedCompanyDetails={setEditedCompanyDetails}
                />
                <ConfirmDialog
                    visible={isConfirmTagDeleteDialogVisible}
                    onHide={() => handleCloseConfirmTagDeleteDialog()}
                    message={"Are you sure you want to delete tag?"}
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    footer={
                        <div>
                            <Button
                                label="No"
                                icon="pi pi-times"
                                onClick={() => handleCloseConfirmTagDeleteDialog()}
                                className="p-button-text"
                                applyThrottle={true}
                            />
                            <Button
                                label="Yes"
                                icon="pi pi-check"
                                onClick={() => handleConfirmDeleteTag()}
                                autoFocus
                                applyThrottle={true}
                            />
                        </div>
                    }
                />
                <Loading visible={isLoading} />      
            </div>
        </>
    )
}

export default CompanyEdit;